import CoinIcon from '../components/CoinIcon';
import React, { useState, useEffect, useCallback } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import api from '../api';
import useIsMobile from '../hooks/useIsMobile';
import { FiUsers, FiCalendar, FiMessageSquare, FiAlertTriangle, FiCheck, FiX, FiEye, FiSend, FiTrash2, FiSearch, FiActivity, FiHelpCircle, FiMail, FiPhone, FiChevronDown, FiChevronRight, FiShield, FiTrendingUp, FiInbox, FiBell, FiExternalLink, FiFilter, FiClock, FiStar, FiImage, FiLock, FiCreditCard, FiZap, FiUpload, FiEdit, FiTag, FiFileText, FiCopy, FiPlus, FiRefreshCw } from 'react-icons/fi';
import { HiOutlineBuildingStorefront } from 'react-icons/hi2';

const TABS = [
  { key: 'overview', label: 'Overview', icon: <FiActivity /> },
  { key: 'invoices', label: 'Invoices', icon: <FiFileText /> },
  { key: 'serviceRequests', label: 'Service Requests', icon: <FiStar /> },
  { key: 'staff', label: 'Staff & Roles', icon: <FiUsers /> },
  { key: 'revenue', label: 'Revenue', icon: <FiTrendingUp /> },
  { key: 'vendors', label: 'Vendors', icon: <HiOutlineBuildingStorefront /> },
  { key: 'vendorRevenue', label: 'Vendor Revenue', icon: <CoinIcon /> },
  { key: 'giftCodes', label: 'Gift Codes', icon: <FiCreditCard /> },
  { key: 'users', label: 'Users', icon: <FiUsers /> },
  { key: 'events', label: 'Events', icon: <FiCalendar /> },
  { key: 'tickets', label: 'Tickets', icon: <FiTag /> },
  { key: 'contributions', label: 'Contributions', icon: <CoinIcon /> },
  { key: 'uploads', label: 'Uploads', icon: <FiImage /> },
  { key: 'banking', label: 'Banking Review', icon: <FiCreditCard /> },
  { key: 'chats', label: 'Chat Monitor', icon: <FiMessageSquare /> },
  { key: 'flagged', label: 'Flagged', icon: <FiAlertTriangle /> },
  { key: 'enquiries', label: 'Enquiries', icon: <FiInbox /> },
  { key: 'faqs', label: 'FAQs', icon: <FiHelpCircle /> },
  { key: 'passwords', label: 'Password Reset', icon: <FiLock /> },
  { key: 'broadcast', label: 'Broadcast', icon: <FiBell /> },
  { key: 'sponsors', label: 'Sponsors', icon: <FiZap /> },
  { key: 'reviews', label: 'Reviews', icon: <FiStar /> },
  { key: 'kgatso', label: 'Kgatso Clients', icon: <FiStar /> },
  { key: 'payouts', label: 'Payouts', icon: <CoinIcon /> },
  { key: 'aiDesign', label: 'AI Designer', icon: <FiZap /> },
  { key: 'guests', label: 'Guests & RSVPs', icon: <FiUsers /> },
  { key: 'traction', label: 'Traction & Growth', icon: <FiTrendingUp /> },
  { key: 'kyc', label: 'KYC Verification', icon: <FiShield /> },
  { key: 'disputes', label: 'Disputes', icon: <FiAlertTriangle /> },
];

export default function AdminDashboard() {
  const { user, logout } = useAuth();
  const [searchParams] = useSearchParams();
  const urlTab = searchParams.get('tab') || localStorage.getItem('adminTab') || 'overview';
  // Staff can only open the sections they were granted; others fall back to overview
  const staffPerms = user?.is_staff ? (user?.staff_permissions || []) : null;
  const allowedTab = (t) => staffPerms ? (staffPerms.includes(t) || t === 'overview' ? t : 'overview') : t;
  const [tab, setTab] = useState(allowedTab(urlTab));
  const [stats, setStats] = useState(null);
  const [vendors, setVendors] = useState([]);
  const [users, setUsers] = useState([]);
  const [events, setEvents] = useState([]);
  const [contributions, setContributions] = useState([]);
  const [chats, setChats] = useState([]);
  const [flagged, setFlagged] = useState([]);
  const [activity, setActivity] = useState([]);
  const [enquiries, setEnquiries] = useState([]);
  const [faqs, setFaqs] = useState([]);
  const [search, setSearch] = useState('');
  const [expandedVendor, setExpandedVendor] = useState(null);
  const [notifyModal, setNotifyModal] = useState(null);
  const [notifyData, setNotifyData] = useState({ title: '', message: '' });
  const [broadcastData, setBroadcastData] = useState({ title: '', message: '', role_filter: '' });
  const [faqForm, setFaqForm] = useState({ question: '', answer: '', category: 'general' });
  const [enquiryNotes, setEnquiryNotes] = useState({});
  const [isMobile, setIsMobile] = useIsMobile(768);
  const [uploads, setUploads] = useState({ gallery: [], proofs: [], portfolio: [] });
  const [bankingReview, setBankingReview] = useState([]);
  const [resetModal, setResetModal] = useState(null);
  const [resetPassword, setResetPassword] = useState('');
  const [sponsorsList, setSponsorsList] = useState([]);
  const [revenueData, setRevenueData] = useState(null);
  const [vendorRevenue, setVendorRevenue] = useState([]);
  const [giftCodes, setGiftCodes] = useState([]);
  const [feedbackList, setFeedbackList] = useState([]);
  const [kgatsoClients, setKgatsoClients] = useState([]);
  const [kgatsoExpanded, setKgatsoExpanded] = useState(null);
  const [payoutsData, setPayoutsData] = useState({ host_withdrawals: [], vendor_withdrawals: [] });
  const [sponsorModal, setSponsorModal] = useState(null);
  const [aiAnalytics, setAiAnalytics] = useState(null);
  const [adminStaff, setAdminStaff] = useState([]);
  const [inviteEmail, setInviteEmail] = useState('');
  const [invitePerms, setInvitePerms] = useState([]);
  const [sponsorForm, setSponsorForm] = useState({ name: '', description: '', tagline: '', website: '', phone: '', email: '', category: '', tier: 'standard', slot_number: '', is_active: true });
  const [guestsList, setGuestsList] = useState([]);
  const [tractionData, setTractionData] = useState(null);
  const [ticketData, setTicketData] = useState(null);
  const [disputesData, setDisputesData] = useState([]);
  const [kycPending, setKycPending] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [serviceRequests, setServiceRequests] = useState([]);
  const [invModal, setInvModal] = useState(null); // null | { invoice } for view, or 'new' for create
  const [invForm, setInvForm] = useState({ client_name: '', client_email: '', client_phone: '', host_name: '', from_name: 'Grand Gather Registry', from_email: 'info@grandgatherregistry.co.za', from_phone: '+27 61 391 1942', banking_details: { bank: 'FNB', account_holder: 'Grand Gather Registry (PTY) LTD', account_number: '63218677285', branch_code: '252945', swift: 'FIRNZAJJ' }, notes: '', items: [{ description: '', quantity: 1, unit_price: 0 }] });
  const [loading, setLoading] = useState(false);

  const loadTab = useCallback(async () => {
    setLoading(true);
    try {
      switch (tab) {
        case 'overview':
          const [s, a] = await Promise.all([api.get('/admin/stats'), api.get('/admin/activity')]);
          setStats(s.data); setActivity(a.data);
          break;
        case 'vendors':
          const v = await api.get('/admin/applications');
          setVendors(v.data);
          break;
        case 'users':
          const u = await api.get('/admin/users');
          setUsers(u.data);
          break;
        case 'events':
          const e = await api.get('/admin/events');
          setEvents(e.data);
          break;
        case 'tickets':
          const td = await api.get('/admin/tickets');
          setTicketData(td.data);
          break;
        case 'contributions':
          const c = await api.get('/admin/contributions');
          setContributions(c.data);
          break;
        case 'chats':
          const ch = await api.get('/admin/chats');
          setChats(ch.data);
          break;
        case 'flagged':
          const f = await api.get('/admin/chats/flagged');
          setFlagged(f.data);
          break;
        case 'enquiries':
          const eq = await api.get('/admin/enquiries');
          setEnquiries(eq.data);
          break;
        case 'faqs':
          const fq = await api.get('/admin/faqs');
          setFaqs(fq.data);
          break;
        case 'uploads':
          const up = await api.get('/admin/uploads');
          setUploads(up.data);
          break;
        case 'banking':
          const bk = await api.get('/admin/banking-review');
          setBankingReview(bk.data);
          break;
        case 'passwords':
          const pu = await api.get('/admin/users');
          setUsers(pu.data);
          break;
        case 'revenue':
          const rv = await api.get('/admin/revenue');
          setRevenueData(rv.data);
          break;
        case 'vendorRevenue':
          const vr = await api.get('/admin/vendor-revenue');
          setVendorRevenue(vr.data);
          break;
        case 'giftCodes':
          const gc = await api.get('/admin/gift-codes');
          setGiftCodes(gc.data);
          break;
        case 'sponsors':
          const sp = await api.get('/admin/sponsors');
          setSponsorsList(sp.data);
          break;
        case 'reviews':
          const fb = await api.get('/admin/feedback');
          setFeedbackList(fb.data);
          break;
        case 'kgatso':
          const kc = await api.get('/admin/kgatso-clients');
          setKgatsoClients(kc.data);
          break;
        case 'payouts':
          const po = await api.get('/admin/withdrawals');
          setPayoutsData(po.data);
          break;
        case 'aiDesign':
          const ai = await api.get('/admin/ai-design-analytics');
          setAiAnalytics(ai.data);
          break;
        case 'guests':
          const gs = await api.get('/admin/guests');
          setGuestsList(gs.data);
          break;
        case 'traction':
          const tr = await api.get('/admin/traction');
          setTractionData(tr.data);
          break;
        case 'staff':
          const st = await api.get('/admin/staff');
          setAdminStaff(st.data);
          break;
        case 'kyc':
          const kyc = await api.get('/admin/kyc/pending');
          setKycPending(kyc.data);
          break;
        case 'invoices':
          const inv = await api.get('/admin/invoices');
          setInvoices(inv.data);
          break;
        case 'serviceRequests':
          const srq = await api.get('/admin/service-requests');
          setServiceRequests(srq.data);
          break;
        case 'disputes':
          const di = await api.get('/admin/disputes');
          setDisputesData(di.data);
          break;
        default: break;
      }
    } catch (e) { console.error('Admin load error:', e); } finally { setLoading(false); }
  }, [tab]);

  useEffect(() => { setTab(allowedTab(urlTab)); }, [urlTab]);
  useEffect(() => { localStorage.setItem('adminTab', tab); }, [tab]);
  useEffect(() => { loadTab(); }, [loadTab]);

  useEffect(() => {
    const handler = () => { api.put('/notifications/read-all').catch(() => {}); };
    window.addEventListener('open-notifications', handler);
    return () => window.removeEventListener('open-notifications', handler);
  }, []);

  const approveVendor = async (id) => {
    await api.put(`/admin/applications/${id}`, { status: 'approved' });
    loadTab();
  };
  const rejectVendor = async (id) => {
    if (!window.confirm('Reject this vendor application?')) return;
    await api.put(`/admin/applications/${id}`, { status: 'rejected' });
    loadTab();
  };
  const sendNotification = async () => {
    if (!notifyData.title || !notifyData.message) return;
    await api.post('/admin/notify', { user_id: notifyModal, ...notifyData });
    setNotifyModal(null); setNotifyData({ title: '', message: '' });
    alert('Notification sent!');
  };
  const sendBroadcast = async () => {
    if (!broadcastData.title || !broadcastData.message) return;
    if (!window.confirm(`Send broadcast to ${broadcastData.role_filter || 'ALL'} users?`)) return;
    const r = await api.post('/admin/broadcast', broadcastData);
    alert(`Broadcast sent to ${r.data.sent} users!`);
    setBroadcastData({ title: '', message: '', role_filter: '' });
  };
  const deleteChat = async (id) => {
    if (!window.confirm('Delete this message?')) return;
    await api.delete(`/admin/chats/${id}`);
    loadTab();
  };
  const addFaq = async () => {
    if (!faqForm.question || !faqForm.answer) return;
    await api.post('/admin/faqs', faqForm);
    setFaqForm({ question: '', answer: '', category: 'general' });
    loadTab();
  };
  const deleteFaq = async (id) => {
    await api.delete(`/admin/faqs/${id}`);
    loadTab();
  };
  const updateEnquiry = async (id, status) => {
    await api.put(`/admin/enquiries/${id}`, { status, admin_notes: enquiryNotes[id] || '' });
    loadTab();
  };

  const fmt = (d) => d ? new Date(d).toLocaleDateString('en-ZA', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—';
  const ago = (d) => {
    if (!d) return '';
    const diff = Date.now() - new Date(d).getTime();
    const mins = Math.floor(diff / 60000);
    if (mins < 60) return `${mins}m ago`;
    const hrs = Math.floor(mins / 60);
    if (hrs < 24) return `${hrs}h ago`;
    return `${Math.floor(hrs / 24)}d ago`;
  };

  const filterList = (list, fields) => {
    if (!search) return list;
    const s = search.toLowerCase();
    return list.filter(item => fields.some(f => String(item[f] || '').toLowerCase().includes(s)));
  };

  // Phone number detection highlight
  const highlightPhones = (text) => {
    if (!text) return text;
    return text.replace(/(\+?27|0)\s*[\d\s\-]{8,}/g, match => `⚠️[${match}]⚠️`);
  };

  const cs = {
    page: { minHeight: '100%', background: '#0F1117', color: '#E8EAF0', fontFamily: "'Inter', -apple-system, sans-serif" },
    sideItem: (active) => ({ display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 20px', cursor: 'pointer', fontSize: '14px', color: active ? '#A78BFA' : '#8B8FA3', background: active ? '#A78BFA12' : 'transparent', borderLeft: active ? '3px solid #A78BFA' : '3px solid transparent', transition: 'all 0.15s', whiteSpace: 'nowrap' }),
    main: { padding: isMobile ? '16px 12px' : '28px 32px' },
    card: { background: '#1A1D2B', borderRadius: '12px', border: '1px solid #252838', padding: '20px', marginBottom: '16px' },
    statCard: (color) => ({ background: '#1A1D2B', borderRadius: '12px', border: '1px solid #252838', padding: '20px', textAlign: 'center', position: 'relative', overflow: 'hidden' }),
    input: { width: '100%', padding: '10px 14px', borderRadius: '8px', border: '1px solid #2A2D3E', background: '#12141E', color: '#E8EAF0', fontSize: '14px', fontFamily: 'Inter, sans-serif', outline: 'none', boxSizing: 'border-box' },
    btn: (bg) => ({ padding: '8px 16px', borderRadius: '8px', border: 'none', background: bg || '#A78BFA', color: '#fff', cursor: 'pointer', fontSize: '13px', fontWeight: 600, fontFamily: 'Inter, sans-serif', display: 'inline-flex', alignItems: 'center', gap: '6px' }),
    btnDanger: { padding: '8px 16px', borderRadius: '8px', border: 'none', background: '#EF444420', color: '#EF4444', cursor: 'pointer', fontSize: '13px', fontWeight: 600, fontFamily: 'Inter, sans-serif', display: 'inline-flex', alignItems: 'center', gap: '6px' },
    btnOutline: { padding: '8px 16px', borderRadius: '8px', border: '1px solid #2A2D3E', background: 'transparent', color: '#8B8FA3', cursor: 'pointer', fontSize: '13px', fontFamily: 'Inter, sans-serif', display: 'inline-flex', alignItems: 'center', gap: '6px' },
    badge: (color) => ({ display: 'inline-block', padding: '3px 10px', borderRadius: '12px', fontSize: '11px', fontWeight: 700, background: `${color}18`, color }),
    th: { padding: '10px 14px', textAlign: 'left', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px', color: '#6B6F82', borderBottom: '1px solid #252838', fontWeight: 600 },
    td: { padding: '12px 14px', fontSize: '13px', borderBottom: '1px solid #1E2030', verticalAlign: 'top' },
    label: { display: 'block', fontSize: '12px', fontWeight: 600, color: '#8B8FA3', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px' },
  };

  const statusColor = (s) => {
    if (s === 'approved') return '#10B981';
    if (s === 'pending') return '#F59E0B';
    if (s === 'rejected' || s === 'suspended') return '#EF4444';
    return '#8B8FA3';
  };

  return (
    <div style={cs.page}>
      {/* Main Content */}
      <div style={cs.main}>
        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px', flexWrap: 'wrap', gap: '12px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div>
              <h1 style={{ fontSize: isMobile ? '18px' : '24px', fontWeight: 700, marginBottom: '4px', color: '#E8EAF0' }}>
                {TABS.find(t => t.key === tab)?.icon} {TABS.find(t => t.key === tab)?.label}
              </h1>
              {!isMobile && <p style={{ fontSize: '13px', color: '#6B6F82', margin: 0 }}>Grand Gather Registry — Internal Management</p>}
            </div>
          </div>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap', width: isMobile ? '100%' : 'auto' }}>
            {['users', 'vendors', 'events', 'contributions', 'chats', 'flagged', 'enquiries'].includes(tab) && (
              <div style={{ position: 'relative', flex: isMobile ? 1 : 'none' }}>
                <FiSearch size={14} style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#6B6F82' }} />
                <input placeholder="Search..." value={search} onChange={e => setSearch(e.target.value)} style={{ ...cs.input, paddingLeft: '36px', width: isMobile ? '100%' : '240px' }} />
              </div>
            )}
            <button onClick={() => loadTab()} disabled={loading} style={{ ...cs.btnOutline, opacity: loading ? 0.6 : 1, cursor: loading ? 'not-allowed' : 'pointer' }}><FiRefreshCw size={14} style={{ animation: loading ? 'spin 0.8s linear infinite' : 'none' }} /> {isMobile ? '' : 'Refresh'}</button>
          </div>
        </div>

        {/* OVERVIEW TAB */}
        {tab === 'overview' && stats && (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '16px', marginBottom: '24px' }}>
              {[
                { label: 'Total Users', value: stats.totalUsers, icon: <FiUsers />, color: '#A78BFA', sub: `+${stats.weeklyUsers} this week · +${stats.recentUsers} this month` },
                { label: 'Total Events', value: stats.totalEvents, icon: <FiCalendar />, color: '#60A5FA', sub: `${stats.activeEvents} active · +${stats.recentEvents} this month` },
                { label: 'Invitations Created', value: stats.totalInvitations, icon: <FiSend />, color: '#E3425C' },
                { label: 'Messages Sent', value: stats.totalMessagesSent, icon: <FiMail />, color: '#F97316', sub: `${stats.messagesDelivered} delivered` },
                { label: 'Total Guests', value: stats.totalGuests, icon: <FiUsers />, color: '#F472B6', sub: `${stats.rsvpAttending} attending · ${stats.rsvpMaybe} maybe` },
                { label: 'Contributions', value: stats.totalContributions, icon: <CoinIcon />, color: '#34D399', sub: `R${stats.totalContributionAmount?.toLocaleString()} total` },
                { label: 'Tickets Sold', value: stats.totalTickets, icon: <FiTag />, color: '#F59E0B', sub: `${stats.checkedInTickets} checked in · +${stats.recentTickets} this week` },
                { label: 'Approved Vendors', value: stats.approvedVendors, icon: <HiOutlineBuildingStorefront />, color: '#10B981', sub: `${stats.pendingVendors} pending` },
                { label: 'Chat Messages', value: stats.totalChatMessages, icon: <FiMessageSquare />, color: '#818CF8' },
              ].map((s, i) => (
                <div key={i} style={cs.statCard(s.color)}>
                  <div style={{ position: 'absolute', top: '14px', right: '14px', color: `${s.color}40`, fontSize: '24px' }}>{s.icon}</div>
                  <div style={{ fontSize: '28px', fontWeight: 800, color: s.color, marginBottom: '4px' }}>{s.value?.toLocaleString()}</div>
                  <div style={{ fontSize: '12px', color: '#6B6F82', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>{s.label}</div>
                  {s.sub && <div style={{ fontSize: '11px', color: '#4ADE80', marginTop: '4px' }}><FiTrendingUp size={10} /> {s.sub}</div>}
                </div>
              ))}
            </div>

            {/* Activity Feed */}
            <div style={cs.card}>
              <h3 style={{ fontSize: '16px', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}><FiActivity size={16} style={{ color: '#A78BFA' }} /> Recent Activity</h3>
              <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
                {activity.map((a, i) => (
                  <div key={i} style={{ display: 'flex', gap: '12px', padding: '12px 0', borderBottom: i < activity.length - 1 ? '1px solid #1E2030' : 'none', alignItems: 'flex-start' }}>
                    <div style={{ width: '32px', height: '32px', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                      background: a.type === 'signup' ? '#A78BFA18' : a.type === 'event' ? '#60A5FA18' : a.type === 'contribution' ? '#10B98118' : '#F59E0B18',
                      color: a.type === 'signup' ? '#A78BFA' : a.type === 'event' ? '#60A5FA' : a.type === 'contribution' ? '#10B981' : '#F59E0B'
                    }}>
                      {a.type === 'signup' ? <FiUsers size={14} /> : a.type === 'event' ? <FiCalendar size={14} /> : a.type === 'contribution' ? <CoinIcon size={14} /> : <HiOutlineBuildingStorefront size={14} />}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '13px', color: '#E8EAF0' }}>
                        {a.type === 'signup' && <><strong>{a.user}</strong> signed up as <span style={cs.badge(a.role === 'vendor' ? '#A78BFA' : '#60A5FA')}>{a.role}</span></>}
                        {a.type === 'event' && <><strong>{a.user}</strong> created event <strong>"{a.title}"</strong></>}
                        {a.type === 'contribution' && <><strong>{a.user}</strong> contributed <span style={{ color: '#10B981', fontWeight: 700 }}>R{Number(a.amount).toLocaleString()}</span> to <strong>{a.gift}</strong></>}
                        {a.type === 'vendor_app' && <><strong>{a.user}</strong> ({a.business}) applied as vendor — <span style={cs.badge(statusColor(a.status))}>{a.status}</span></>}
                      </div>
                      <div style={{ fontSize: '11px', color: '#6B6F82', marginTop: '2px' }}>{ago(a.time)}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}

        {/* VENDORS TAB */}
        {tab === 'vendors' && (
          <div style={cs.card}>
            <div style={{ display: 'flex', gap: '8px', marginBottom: '16px', flexWrap: 'wrap' }}>
              {['all', 'pending', 'approved', 'rejected'].map(f => (
                <button key={f} onClick={() => setSearch(f === 'all' ? '' : f)} style={{ ...cs.btnOutline, background: search === f || (f === 'all' && !search) ? '#A78BFA18' : 'transparent', color: search === f || (f === 'all' && !search) ? '#A78BFA' : '#8B8FA3' }}>
                  {f.charAt(0).toUpperCase() + f.slice(1)}
                </button>
              ))}
            </div>
            <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '800px' }}>
              <thead>
                <tr>
                  <th style={cs.th}>Business</th>
                  <th style={cs.th}>Contact</th>
                  <th style={cs.th}>Category</th>
                  <th style={cs.th}>Location</th>
                  <th style={cs.th}>Status</th>
                  <th style={cs.th}>Applied</th>
                  <th style={cs.th}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filterList(vendors, ['name', 'email', 'business_name', 'business_category', 'vendor_status']).map(v => (
                  <React.Fragment key={v.id}>
                    <tr style={{ cursor: 'pointer' }} onClick={() => setExpandedVendor(expandedVendor === v.id ? null : v.id)}>
                      <td style={cs.td}>
                        <div style={{ fontWeight: 600 }}>{v.business_name || '—'}</div>
                        <div style={{ fontSize: '11px', color: '#6B6F82' }}>{v.name}</div>
                      </td>
                      <td style={cs.td}>
                        <div style={{ fontSize: '12px' }}>{v.email}</div>
                        {v.phone && <div style={{ fontSize: '11px', color: '#6B6F82' }}><FiPhone size={10} /> {v.phone}</div>}
                      </td>
                      <td style={cs.td}><span style={cs.badge('#A78BFA')}>{v.business_category || '—'}</span></td>
                      <td style={cs.td}><span style={{ fontSize: '12px', color: '#8B8FA3' }}>{v.business_location || '—'}</span></td>
                      <td style={cs.td}><span style={cs.badge(statusColor(v.vendor_status))}>{v.vendor_status || 'none'}</span></td>
                      <td style={cs.td}><span style={{ fontSize: '12px', color: '#6B6F82' }}>{fmt(v.vendor_applied_at)}</span></td>
                      <td style={cs.td}>
                        <div style={{ display: 'flex', gap: '6px' }} onClick={e => e.stopPropagation()}>
                          {v.vendor_status === 'pending' && (
                            <>
                              <button onClick={() => approveVendor(v.id)} style={cs.btn('#10B981')}><FiCheck size={12} /> Approve</button>
                              <button onClick={() => rejectVendor(v.id)} style={cs.btnDanger}><FiX size={12} /> Reject</button>
                            </>
                          )}
                          {v.vendor_status === 'approved' && <button onClick={() => { api.put(`/admin/users/${v.id}/status`, { action: 'suspend' }); loadTab(); }} style={cs.btnDanger}><FiShield size={12} /> Suspend</button>}
                          {v.vendor_status === 'suspended' && <button onClick={() => { api.put(`/admin/users/${v.id}/status`, { action: 'activate' }); loadTab(); }} style={cs.btn('#10B981')}><FiCheck size={12} /> Reactivate</button>}
                          <button onClick={() => setNotifyModal(v.id)} style={cs.btnOutline}><FiSend size={12} /> Message</button>
                        </div>
                      </td>
                    </tr>
                    {expandedVendor === v.id && (
                      <tr>
                        <td colSpan={7} style={{ ...cs.td, background: '#12141E', padding: '16px 20px' }}>
                          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                            <div>
                              <div style={cs.label}>Business Description</div>
                              <p style={{ fontSize: '13px', color: '#8B8FA3', lineHeight: 1.6, margin: 0 }}>{v.business_description || 'No description provided'}</p>
                            </div>
                            <div>
                              <div style={cs.label}>Details</div>
                              <div style={{ fontSize: '13px', color: '#8B8FA3' }}>
                                <div>Price Range: <strong style={{ color: '#E8EAF0' }}>{v.business_price_range || '—'}</strong></div>
                                <div>WhatsApp: <strong style={{ color: '#E8EAF0' }}>{v.whatsapp_number || '—'}</strong></div>
                                <div>Address: <strong style={{ color: '#E8EAF0' }}>{v.business_address || '—'}</strong></div>
                                <div>Service Areas: <strong style={{ color: '#E8EAF0' }}>{v.service_areas || '—'}</strong></div>
                                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '4px' }}>
                                  {v.social_facebook && <a href={v.social_facebook.startsWith('http') ? v.social_facebook : `https://${v.social_facebook}`} target="_blank" rel="noopener noreferrer" style={{ fontSize: '11px', color: '#60A5FA', textDecoration: 'underline' }}>Facebook</a>}
                                  {v.social_instagram && <a href={v.social_instagram.startsWith('http') ? v.social_instagram : `https://${v.social_instagram}`} target="_blank" rel="noopener noreferrer" style={{ fontSize: '11px', color: '#F472B6', textDecoration: 'underline' }}>Instagram</a>}
                                  {v.social_tiktok && <a href={v.social_tiktok.startsWith('http') ? v.social_tiktok : `https://${v.social_tiktok}`} target="_blank" rel="noopener noreferrer" style={{ fontSize: '11px', color: '#A78BFA', textDecoration: 'underline' }}>TikTok</a>}
                                  {v.social_website && <a href={v.social_website.startsWith('http') ? v.social_website : `https://${v.social_website}`} target="_blank" rel="noopener noreferrer" style={{ fontSize: '11px', color: '#34D399', textDecoration: 'underline' }}>Website</a>}
                                  {!v.social_facebook && !v.social_instagram && !v.social_tiktok && !v.social_website && <span style={{ fontSize: '11px', color: '#F87171' }}>No socials provided</span>}
                                </div>
                                {v.vendor_approved_at && <div>Approved: <strong style={{ color: '#10B981' }}>{fmt(v.vendor_approved_at)}</strong></div>}
                              </div>
                            </div>
                          </div>
                          {/* Business Gallery for review */}
                          {v.business_gallery && v.business_gallery.length > 0 && (
                            <div style={{ marginTop: '16px', borderTop: '1px solid #1E2030', paddingTop: '16px' }}>
                              <div style={{ ...cs.label, marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                Business Gallery ({v.business_gallery.length}/5)
                                <span style={{ fontSize: '10px', color: '#F59E0B', fontWeight: 400 }}>— Review for stolen/inappropriate content</span>
                              </div>
                              <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                {v.business_gallery.map((url, i) => (
                                  <a key={i} href={url} target="_blank" rel="noopener noreferrer" style={{ display: 'block' }}>
                                    <img src={url} alt={`Gallery ${i + 1}`} style={{ width: '120px', height: '120px', borderRadius: '10px', objectFit: 'cover', border: '2px solid #2A2D3E' }} />
                                  </a>
                                ))}
                              </div>
                            </div>
                          )}
                          {v.logo_url && (
                            <div style={{ marginTop: '12px', borderTop: '1px solid #1E2030', paddingTop: '12px' }}>
                              <div style={{ ...cs.label, marginBottom: '8px' }}>Business Logo</div>
                              <a href={v.logo_url} target="_blank" rel="noopener noreferrer">
                                <img src={v.logo_url} alt="Logo" style={{ width: '80px', height: '80px', borderRadius: '10px', objectFit: 'cover', border: '2px solid #2A2D3E' }} />
                              </a>
                            </div>
                          )}
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
            </div>
            {vendors.length === 0 && <p style={{ textAlign: 'center', color: '#6B6F82', padding: '40px' }}>No vendor applications yet</p>}
          </div>
        )}

        {/* USERS TAB */}
        {tab === 'users' && (
          <div style={cs.card}>
            <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '700px' }}>
              <thead>
                <tr>
                  <th style={cs.th}>Name</th>
                  <th style={cs.th}>Email</th>
                  <th style={cs.th}>Role</th>
                  <th style={cs.th}>Events</th>
                  <th style={cs.th}>Joined</th>
                  <th style={cs.th}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filterList(users, ['name', 'email', 'role', 'business_name']).map(u => (
                  <tr key={u.id}>
                    <td style={cs.td}>
                      <div style={{ fontWeight: 600 }}>{u.name}</div>
                      {u.business_name && <div style={{ fontSize: '11px', color: '#6B6F82' }}>{u.business_name}</div>}
                    </td>
                    <td style={cs.td}><span style={{ fontSize: '13px' }}>{u.email}</span></td>
                    <td style={cs.td}>
                      <span style={cs.badge(u.role === 'vendor' ? '#A78BFA' : '#60A5FA')}>{u.role}</span>
                      {u.is_admin && <span style={{ ...cs.badge('#F59E0B'), marginLeft: '4px' }}>admin</span>}
                    </td>
                    <td style={cs.td}><span style={{ fontWeight: 600 }}>{u.event_count}</span></td>
                    <td style={cs.td}><span style={{ fontSize: '12px', color: '#6B6F82' }}>{fmt(u.created_at)}</span></td>
                    <td style={cs.td}>
                      <div style={{ display: 'flex', gap: '6px' }}>
                        <button onClick={() => setNotifyModal(u.id)} style={cs.btnOutline}><FiSend size={12} /> Message</button>
                        {u.role === 'vendor' && u.vendor_status === 'approved' && (
                          <button onClick={async () => { await api.put(`/admin/users/${u.id}/status`, { action: 'suspend' }); loadTab(); }} style={cs.btnDanger}><FiShield size={12} /></button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          </div>
        )}

        {/* EVENTS TAB */}
        {tab === 'events' && (
          <div style={cs.card}>
            <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '800px' }}>
              <thead>
                <tr>
                  <th style={cs.th}>Event</th>
                  <th style={cs.th}>Host</th>
                  <th style={cs.th}>Type</th>
                  <th style={cs.th}>Date</th>
                  <th style={cs.th}>Guests</th>
                  <th style={cs.th}>Registry</th>
                  <th style={cs.th}>Bank Details</th>
                  <th style={cs.th}>Created</th>
                </tr>
              </thead>
              <tbody>
                {filterList(events, ['title', 'host_name', 'host_email', 'event_type', 'location']).map(e => (
                  <tr key={e.id}>
                    <td style={cs.td}>
                      <div style={{ fontWeight: 600 }}>{e.title}</div>
                      <div style={{ fontSize: '11px', color: '#6B6F82' }}>{e.location || '—'}</div>
                    </td>
                    <td style={cs.td}>
                      <div style={{ fontSize: '13px' }}>{e.host_name}</div>
                      <div style={{ fontSize: '11px', color: '#6B6F82' }}>{e.host_email}</div>
                    </td>
                    <td style={cs.td}><span style={cs.badge('#818CF8')}>{e.event_type || '—'}</span></td>
                    <td style={cs.td}><span style={{ fontSize: '12px' }}>{e.event_date ? new Date(e.event_date).toLocaleDateString('en-ZA') : '—'}</span></td>
                    <td style={cs.td}><span style={{ fontWeight: 600 }}>{e.guest_count}</span></td>
                    <td style={cs.td}><span style={{ fontWeight: 600 }}>{e.registry_count}</span></td>
                    <td style={cs.td}>
                      {e.bank_details ? (
                        <span style={{ ...cs.badge('#10B981'), cursor: 'pointer' }} title={e.bank_details}><FiEye size={10} /> Set</span>
                      ) : (
                        <span style={cs.badge('#6B6F82')}>None</span>
                      )}
                    </td>
                    <td style={cs.td}><span style={{ fontSize: '12px', color: '#6B6F82' }}>{ago(e.created_at)}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          </div>
        )}

        {/* TICKETS TAB */}
        {tab === 'tickets' && (
          <div style={cs.card}>
            <h3 style={{ fontSize: '16px', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}><FiTag size={16} style={{ color: '#F59E0B' }} /> Ticket Sales Tracker</h3>
            {ticketData && (
              <>
                {/* Summary Stats */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '12px', marginBottom: '24px' }}>
                  {[
                    { label: 'Tickets Sold', value: ticketData.revenue?.sold_count || 0, color: '#F59E0B' },
                    { label: 'Total Revenue', value: 'R' + parseFloat(ticketData.revenue?.total_revenue || 0).toLocaleString('en-ZA', { maximumFractionDigits: 2 }), color: '#34D399' },
                    { label: 'GGR Commission', value: 'R' + parseFloat(ticketData.revenue?.total_commission || 0).toLocaleString('en-ZA', { maximumFractionDigits: 2 }), color: '#E3425C' },
                    { label: 'Events with Tickets', value: ticketData.events?.length || 0, color: '#60A5FA' },
                    { label: 'Checked In', value: ticketData.events?.reduce((s, e) => s + parseInt(e.checked_in), 0) || 0, color: '#A78BFA' },
                    { label: 'Ticket Tiers', value: ticketData.tiers?.length || 0, color: '#6B6F82' },
                  ].map((s, i) => (
                    <div key={i} style={{ background: '#1E2030', borderRadius: '10px', padding: '14px', textAlign: 'center' }}>
                      <div style={{ fontSize: '24px', fontWeight: 800, color: s.color, marginBottom: '4px' }}>{s.value?.toLocaleString()}</div>
                      <div style={{ fontSize: '11px', color: '#6B6F82', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>{s.label}</div>
                    </div>
                  ))}
                </div>

                {/* Tickets Sold Table */}
                <h4 style={{ fontSize: '14px', fontWeight: 700, color: '#E8EAF0', marginBottom: '12px' }}>Tickets Sold</h4>
                <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch', marginBottom: '28px' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '800px' }}>
                    <thead>
                      <tr>
                        <th style={cs.th}>Ticket Code</th>
                        <th style={cs.th}>Buyer</th>
                        <th style={cs.th}>Event</th>
                        <th style={cs.th}>Tier</th>
                        <th style={cs.th}>Price</th>
                        <th style={cs.th}>Payment</th>
                        <th style={cs.th}>Date</th>
                        <th style={cs.th}>Checked In</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ticketData.sold?.map((t, i) => (
                        <tr key={i} style={{ borderBottom: '1px solid #1E2030' }}>
                          <td style={{ ...cs.td, fontFamily: 'monospace', fontSize: '11px', color: '#E8EAF0' }}>{t.ticket_code}</td>
                          <td style={cs.td}>{t.buyer_name || t.guest_name || '—'}</td>
                          <td style={{ ...cs.td, fontWeight: 600, color: '#E8EAF0' }}>{t.event_title}</td>
                          <td style={cs.td}>{t.tier_name || '—'}</td>
                          <td style={{ ...cs.td, color: parseFloat(t.price_paid) > 0 ? '#34D399' : '#6B6F82', fontWeight: 600 }}>
                            {parseFloat(t.price_paid) > 0 ? 'R' + parseFloat(t.price_paid).toFixed(2) : 'Free'}
                          </td>
                          <td style={cs.td}>
                            <span style={{ ...cs.badge(t.payment_status === 'paid' ? '#34D399' : t.payment_status === 'free' ? '#6B6F82' : '#F59E0B'), fontSize: '11px' }}>
                              {t.payment_status}
                            </span>
                          </td>
                          <td style={cs.td}>{t.created_at ? new Date(t.created_at).toLocaleDateString('en-ZA') : '—'}</td>
                          <td style={cs.td}>
                            <span style={{ ...cs.badge(t.checked_in ? '#34D399' : '#1E2030'), fontSize: '11px' }}>
                              {t.checked_in ? 'Yes' : 'No'}
                            </span>
                          </td>
                        </tr>
                      ))}
                      {(!ticketData.sold || ticketData.sold.length === 0) && (
                        <tr><td colSpan={8} style={{ ...cs.td, textAlign: 'center', color: '#6B6F82', padding: '32px' }}>No tickets sold yet</td></tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Events with Tickets Table */}
                <h4 style={{ fontSize: '14px', fontWeight: 700, color: '#E8EAF0', marginBottom: '12px' }}>Events with Tickets</h4>
                <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch', marginBottom: '28px' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '600px' }}>
                    <thead>
                      <tr>
                        <th style={cs.th}>Event</th>
                        <th style={cs.th}>Host</th>
                        <th style={cs.th}>Date</th>
                        <th style={cs.th}>Sold</th>
                        <th style={cs.th}>Checked In</th>
                        <th style={cs.th}>Rate</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ticketData.events?.map((ev, i) => {
                        const total = parseInt(ev.total_tickets);
                        const checked = parseInt(ev.checked_in);
                        const rate = total > 0 ? Math.round((checked / total) * 100) : 0;
                        return (
                          <tr key={i} style={{ borderBottom: '1px solid #1E2030' }}>
                            <td style={{ ...cs.td, fontWeight: 600, color: '#E8EAF0' }}>{ev.title}</td>
                            <td style={cs.td}>{ev.host_name}</td>
                            <td style={cs.td}>{ev.event_date ? new Date(ev.event_date).toLocaleDateString('en-ZA') : '—'}</td>
                            <td style={cs.td}>{total}</td>
                            <td style={cs.td}>{checked}</td>
                            <td style={cs.td}>
                              <span style={{ color: rate >= 70 ? '#34D399' : rate >= 30 ? '#F59E0B' : '#EF4444', fontWeight: 600 }}>
                                {rate}%
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                      {(!ticketData.events || ticketData.events.length === 0) && (
                        <tr><td colSpan={6} style={{ ...cs.td, textAlign: 'center', color: '#6B6F82', padding: '32px' }}>No ticket data yet</td></tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Ticket Tiers */}
                <h4 style={{ fontSize: '14px', fontWeight: 700, color: '#E8EAF0', marginBottom: '12px' }}>Ticket Tiers</h4>
                <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '500px' }}>
                    <thead>
                      <tr>
                        <th style={cs.th}>Tier Name</th>
                        <th style={cs.th}>Event</th>
                        <th style={cs.th}>Price</th>
                        <th style={cs.th}>Availability</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ticketData.tiers?.map((t, i) => (
                        <tr key={i} style={{ borderBottom: '1px solid #1E2030' }}>
                          <td style={{ ...cs.td, fontWeight: 600, color: '#E8EAF0' }}>{t.name}</td>
                          <td style={cs.td}>{t.event_title || `Event #${t.event_id}`}</td>
                          <td style={{ ...cs.td, color: '#34D399', fontWeight: 600 }}>R{parseFloat(t.price).toLocaleString()}</td>
                          <td style={cs.td}>
                            <span style={{ ...cs.badge(t.available !== false ? '#34D399' : '#EF4444'), fontSize: '11px' }}>
                              {t.available !== false ? 'Available' : 'Sold Out'}
                            </span>
                          </td>
                        </tr>
                      ))}
                      {(!ticketData.tiers || ticketData.tiers.length === 0) && (
                        <tr><td colSpan={4} style={{ ...cs.td, textAlign: 'center', color: '#6B6F82', padding: '24px' }}>No ticket tiers found</td></tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </>
            )}
            {!ticketData && <div style={{ textAlign: 'center', padding: '40px', color: '#6B6F82' }}>Loading ticket data...</div>}
          </div>
        )}

        {/* CONTRIBUTIONS TAB */}
        {tab === 'contributions' && (
          <div style={cs.card}>
            <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '750px' }}>
              <thead>
                <tr>
                  <th style={cs.th}>Contributor</th>
                  <th style={cs.th}>Gift</th>
                  <th style={cs.th}>Event</th>
                  <th style={cs.th}>Amount</th>
                  <th style={cs.th}>Proof</th>
                  <th style={cs.th}>Status</th>
                  <th style={cs.th}>Date</th>
                </tr>
              </thead>
              <tbody>
                {filterList(contributions, ['contributor_name', 'gift_title', 'event_title']).map(c => (
                  <tr key={c.id}>
                    <td style={cs.td}><strong>{c.contributor_name}</strong></td>
                    <td style={cs.td}>{c.gift_title}</td>
                    <td style={cs.td}><span style={{ fontSize: '12px', color: '#8B8FA3' }}>{c.event_title}</span></td>
                    <td style={cs.td}>
                      {Number(c.amount) > 0 ? (
                        <span style={{ fontWeight: 700, color: '#10B981' }}>R{Number(c.amount).toLocaleString()}</span>
                      ) : <span style={{ color: '#6B6F82' }}>Gift claim</span>}
                    </td>
                    <td style={cs.td}>
                      {c.proof_of_payment ? (
                        <a href={c.proof_of_payment} target="_blank" rel="noreferrer" style={{ color: '#60A5FA', fontSize: '12px', display: 'flex', alignItems: 'center', gap: '4px' }}><FiExternalLink size={12} /> View</a>
                      ) : <span style={cs.badge('#F59E0B')}>None</span>}
                    </td>
                    <td style={cs.td}><span style={cs.badge(statusColor(c.payment_status === 'confirmed' ? 'approved' : c.payment_status))}>{c.payment_status}</span></td>
                    <td style={cs.td}><span style={{ fontSize: '12px', color: '#6B6F82' }}>{fmt(c.created_at)}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
            {contributions.length === 0 && <p style={{ textAlign: 'center', color: '#6B6F82', padding: '40px' }}>No contributions yet</p>}
          </div>
        )}

        {/* CHAT MONITOR TAB */}
        {tab === 'chats' && (
          <div style={cs.card}>
            <p style={{ fontSize: '12px', color: '#6B6F82', marginBottom: '16px' }}><FiAlertTriangle size={12} style={{ color: '#F59E0B' }} /> Monitoring vendor-host conversations. Phone numbers and suspicious content are highlighted.</p>
            <div style={{ maxHeight: '600px', overflowY: 'auto' }}>
              {filterList(chats, ['content', 'sender_name', 'other_name']).map(m => (
                <div key={m.id} style={{ display: 'flex', gap: '12px', padding: '10px 0', borderBottom: '1px solid #1E2030', alignItems: 'flex-start' }}>
                  <div style={{ width: '36px', height: '36px', borderRadius: '50%', background: '#A78BFA18', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontSize: '14px', fontWeight: 700, color: '#A78BFA' }}>
                    {m.sender_name?.charAt(0)}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
                      <div style={{ fontSize: '13px' }}><strong style={{ color: '#E8EAF0' }}>{m.sender_name}</strong> <span style={{ color: '#6B6F82' }}>→</span> <strong style={{ color: '#8B8FA3' }}>{m.other_name}</strong></div>
                      <span style={{ fontSize: '11px', color: '#6B6F82' }}>{ago(m.created_at)}</span>
                    </div>
                    <div style={{ fontSize: '13px', color: '#8B8FA3', lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>{highlightPhones(m.content)}</div>
                  </div>
                  <button onClick={() => deleteChat(m.id)} style={{ ...cs.btnDanger, padding: '6px 8px' }} title="Delete message"><FiTrash2 size={12} /></button>
                </div>
              ))}
            </div>
            {chats.length === 0 && <p style={{ textAlign: 'center', color: '#6B6F82', padding: '40px' }}>No chat messages</p>}
          </div>
        )}

        {/* FLAGGED TAB */}
        {tab === 'flagged' && (
          <div style={cs.card}>
            <div style={{ padding: '14px', background: '#EF444410', borderRadius: '10px', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <FiAlertTriangle size={18} style={{ color: '#EF4444' }} />
              <div>
                <div style={{ fontSize: '14px', fontWeight: 600, color: '#EF4444' }}>Flagged Messages ({flagged.length})</div>
                <div style={{ fontSize: '12px', color: '#8B8FA3' }}>Messages containing phone numbers, "WhatsApp", "call me", bank details, or suspicious payment language</div>
              </div>
            </div>
            <div style={{ maxHeight: '600px', overflowY: 'auto' }}>
              {filterList(flagged, ['content', 'sender_name', 'other_name']).map(m => (
                <div key={m.id} style={{ padding: '14px', background: '#EF444408', borderRadius: '10px', border: '1px solid #EF444420', marginBottom: '10px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                    <div style={{ fontSize: '13px' }}>
                      <strong>{m.sender_name}</strong> <span style={cs.badge(m.sender_role === 'vendor' ? '#A78BFA' : '#60A5FA')}>{m.sender_role}</span>
                      <span style={{ color: '#6B6F82', margin: '0 6px' }}>→</span>
                      <strong>{m.other_name}</strong> <span style={cs.badge(m.other_role === 'vendor' ? '#A78BFA' : '#60A5FA')}>{m.other_role}</span>
                    </div>
                    <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                      <span style={{ fontSize: '11px', color: '#6B6F82' }}>{fmt(m.created_at)}</span>
                      <button onClick={() => deleteChat(m.id)} style={cs.btnDanger}><FiTrash2 size={12} /> Delete</button>
                      <button onClick={() => setNotifyModal(m.sender_id)} style={cs.btnOutline}><FiSend size={12} /> Warn</button>
                    </div>
                  </div>
                  <div style={{ fontSize: '14px', color: '#E8EAF0', lineHeight: 1.6, padding: '10px', background: '#12141E', borderRadius: '8px', whiteSpace: 'pre-wrap' }}>{highlightPhones(m.content)}</div>
                </div>
              ))}
            </div>
            {flagged.length === 0 && <div style={{ textAlign: 'center', padding: '60px', color: '#6B6F82' }}><FiCheck size={40} style={{ marginBottom: '12px', color: '#10B981' }} /><p>No flagged messages. All clear!</p></div>}
          </div>
        )}

        {/* ENQUIRIES TAB */}
        {tab === 'enquiries' && (
          <div style={cs.card}>
            {enquiries.length === 0 ? (
              <p style={{ textAlign: 'center', color: '#6B6F82', padding: '40px' }}>No enquiries yet</p>
            ) : (
              filterList(enquiries, ['name', 'email', 'subject', 'message']).map(eq => (
                <div key={eq.id} style={{ padding: '16px', borderRadius: '10px', border: '1px solid #252838', marginBottom: '12px', background: eq.status === 'new' ? '#A78BFA06' : 'transparent' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                    <div>
                      <strong style={{ fontSize: '15px' }}>{eq.subject || 'No subject'}</strong>
                      <span style={{ ...cs.badge(eq.status === 'new' ? '#F59E0B' : eq.status === 'resolved' ? '#10B981' : '#60A5FA'), marginLeft: '8px' }}>{eq.status}</span>
                    </div>
                    <span style={{ fontSize: '12px', color: '#6B6F82' }}>{fmt(eq.created_at)}</span>
                  </div>
                  <div style={{ fontSize: '13px', color: '#8B8FA3', marginBottom: '8px' }}>
                    <strong>{eq.name}</strong> · {eq.email} {eq.phone && <span>· <FiPhone size={10} /> {eq.phone}</span>}
                  </div>
                  <p style={{ fontSize: '14px', color: '#E8EAF0', lineHeight: 1.6, margin: '0 0 12px', whiteSpace: 'pre-wrap' }}>{eq.message}</p>
                  <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-end' }}>
                    <div style={{ flex: 1 }}>
                      <input placeholder="Admin notes..." value={enquiryNotes[eq.id] || eq.admin_notes || ''} onChange={e => setEnquiryNotes({ ...enquiryNotes, [eq.id]: e.target.value })} style={cs.input} />
                    </div>
                    <button onClick={() => updateEnquiry(eq.id, 'in_progress')} style={cs.btn('#60A5FA')}>In Progress</button>
                    <button onClick={() => updateEnquiry(eq.id, 'resolved')} style={cs.btn('#10B981')}><FiCheck size={12} /> Resolve</button>
                  </div>
                </div>
              ))
            )}
          </div>
        )}

        {/* FAQS TAB */}
        {tab === 'faqs' && (
          <>
            <div style={cs.card}>
              <h4 style={{ marginBottom: '16px', fontSize: '15px' }}>Add New FAQ</h4>
              <div style={{ display: 'grid', gap: '12px' }}>
                <div>
                  <label style={cs.label}>Category</label>
                  <select value={faqForm.category} onChange={e => setFaqForm({ ...faqForm, category: e.target.value })} style={cs.input}>
                    <option value="general">General</option>
                    <option value="hosts">For Hosts</option>
                    <option value="vendors">For Vendors</option>
                    <option value="guests">For Guests</option>
                    <option value="payments">Payments</option>
                    <option value="account">Account</option>
                  </select>
                </div>
                <div>
                  <label style={cs.label}>Question</label>
                  <input value={faqForm.question} onChange={e => setFaqForm({ ...faqForm, question: e.target.value })} placeholder="e.g., How do I add a gift to my registry?" style={cs.input} />
                </div>
                <div>
                  <label style={cs.label}>Answer</label>
                  <textarea value={faqForm.answer} onChange={e => setFaqForm({ ...faqForm, answer: e.target.value })} rows={3} placeholder="The detailed answer..." style={{ ...cs.input, resize: 'vertical' }} />
                </div>
                <button onClick={addFaq} style={{ ...cs.btn('#A78BFA'), alignSelf: 'flex-start' }}><FiPlus size={14} /> Add FAQ</button>
              </div>
            </div>
            <div style={cs.card}>
              <h4 style={{ marginBottom: '16px', fontSize: '15px' }}>Existing FAQs ({faqs.length})</h4>
              {faqs.map(f => (
                <div key={f.id} style={{ padding: '14px', borderRadius: '8px', border: '1px solid #252838', marginBottom: '10px', display: 'flex', gap: '12px' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                      <span style={cs.badge('#A78BFA')}>{f.category}</span>
                      <strong style={{ fontSize: '14px' }}>{f.question}</strong>
                    </div>
                    <p style={{ fontSize: '13px', color: '#8B8FA3', margin: 0, lineHeight: 1.5 }}>{f.answer}</p>
                  </div>
                  <button onClick={() => deleteFaq(f.id)} style={{ ...cs.btnDanger, padding: '6px 8px', height: 'fit-content' }}><FiTrash2 size={12} /></button>
                </div>
              ))}
              {faqs.length === 0 && <p style={{ color: '#6B6F82', textAlign: 'center', padding: '30px' }}>No FAQs yet. Add your first one above.</p>}
            </div>
          </>
        )}

        {/* BROADCAST TAB */}
        {tab === 'broadcast' && (
          <div style={cs.card}>
            <h4 style={{ marginBottom: '16px', fontSize: '15px', display: 'flex', alignItems: 'center', gap: '8px' }}><FiBell style={{ color: '#A78BFA' }} /> Send Broadcast Notification</h4>
            <p style={{ fontSize: '13px', color: '#6B6F82', marginBottom: '20px' }}>This sends a notification to all users (or filtered by role). They'll see it in their notification bell.</p>
            <div style={{ display: 'grid', gap: '16px', maxWidth: '500px' }}>
              <div>
                <label style={cs.label}>Audience</label>
                <select value={broadcastData.role_filter} onChange={e => setBroadcastData({ ...broadcastData, role_filter: e.target.value })} style={cs.input}>
                  <option value="">All Users</option>
                  <option value="host">Hosts Only</option>
                  <option value="vendor">Vendors Only</option>
                </select>
              </div>
              <div>
                <label style={cs.label}>Title</label>
                <input value={broadcastData.title} onChange={e => setBroadcastData({ ...broadcastData, title: e.target.value })} placeholder="e.g., New Feature: Gift Registry Improvements" style={cs.input} />
              </div>
              <div>
                <label style={cs.label}>Message</label>
                <textarea value={broadcastData.message} onChange={e => setBroadcastData({ ...broadcastData, message: e.target.value })} rows={4} placeholder="Write your message here..." style={{ ...cs.input, resize: 'vertical' }} />
              </div>
              <button onClick={sendBroadcast} disabled={!broadcastData.title || !broadcastData.message} style={{ ...cs.btn('#A78BFA'), alignSelf: 'flex-start', opacity: (!broadcastData.title || !broadcastData.message) ? 0.5 : 1 }}><FiSend size={14} /> Send Broadcast</button>
            </div>
          </div>
        )}

        {/* SPONSORS TAB */}
        {/* REVENUE DASHBOARD */}
        {tab === 'revenue' && (
          <>
            <h3 style={{ fontSize: '18px', marginBottom: '20px' }}>Platform Revenue Overview</h3>
            {revenueData ? (
              <>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', marginBottom: '24px' }}>
                  <div style={{ ...cs.card, textAlign: 'center', padding: '24px' }}>
                    <div style={{ fontSize: '12px', color: '#6B6F82', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px' }}>Total Revenue</div>
                    <div style={{ fontSize: '28px', fontWeight: 700, color: '#10B981' }}>R{Number(revenueData.total_revenue).toLocaleString()}</div>
                  </div>
                  <div style={{ ...cs.card, textAlign: 'center', padding: '24px' }}>
                    <div style={{ fontSize: '12px', color: '#6B6F82', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px' }}>This Month</div>
                    <div style={{ fontSize: '28px', fontWeight: 700, color: '#A78BFA' }}>R{Number(revenueData.revenue_this_month).toLocaleString()}</div>
                  </div>
                  <div style={{ ...cs.card, textAlign: 'center', padding: '24px' }}>
                    <div style={{ fontSize: '12px', color: '#6B6F82', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px' }}>Sponsor Income/mo</div>
                    <div style={{ fontSize: '28px', fontWeight: 700, color: '#C9A84C' }}>R{Number(revenueData.sponsor_monthly_income).toLocaleString()}</div>
                  </div>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                  <div style={cs.card}>
                    <h4 style={{ fontSize: '15px', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}><FiCreditCard size={16} style={{ color: '#A78BFA' }} /> Gift Code Revenue</h4>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px' }}>
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '22px', fontWeight: 700, color: '#E0E4F0' }}>{revenueData.gift_codes?.total || 0}</div>
                        <div style={{ fontSize: '11px', color: '#6B6F82' }}>Codes Generated</div>
                      </div>
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '22px', fontWeight: 700, color: '#10B981' }}>{revenueData.gift_codes?.redeemed || 0}</div>
                        <div style={{ fontSize: '11px', color: '#6B6F82' }}>Redeemed</div>
                      </div>
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '22px', fontWeight: 700, color: '#C9A84C' }}>R{Number(revenueData.gift_codes?.earned || 0).toLocaleString()}</div>
                        <div style={{ fontSize: '11px', color: '#6B6F82' }}>Commission Earned</div>
                      </div>
                    </div>
                  </div>
                  <div style={cs.card}>
                    <h4 style={{ fontSize: '15px', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}><HiOutlineBuildingStorefront size={16} style={{ color: '#10B981' }} /> Vendor Bookings</h4>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '22px', fontWeight: 700, color: '#E0E4F0' }}>{revenueData.vendor_bookings?.total || 0}</div>
                        <div style={{ fontSize: '11px', color: '#6B6F82' }}>Total Bookings</div>
                      </div>
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '22px', fontWeight: 700, color: '#10B981' }}>R{Number(revenueData.vendor_bookings?.total_value || 0).toLocaleString()}</div>
                        <div style={{ fontSize: '11px', color: '#6B6F82' }}>Total Value</div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : <div style={{ ...cs.card, textAlign: 'center', padding: '40px', color: '#6B6F82' }}>Loading revenue data...</div>}
          </>
        )}

        {/* VENDOR REVENUE TRACKING */}
        {tab === 'vendorRevenue' && (
          <>
            <h3 style={{ fontSize: '18px', marginBottom: '20px' }}>Vendor Revenue & Commission Tracking</h3>
            <div style={{ ...cs.card, marginBottom: '16px', padding: '16px 20px', background: 'linear-gradient(135deg, #1A1D2E, #12141E)', border: '1px solid #C9A84C33' }}>
              <p style={{ fontSize: '13px', color: '#C9A84C' }}>First R5,000 earned commission-free. Commission thereafter: Starter (Free) = 8%, Pro (R199/mo) = 3%, Premium (R499/mo) = 0%</p>
            </div>
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ borderBottom: '1px solid #252838' }}>
                    {['Vendor', 'Business', 'Plan', 'Bookings (Month)', 'Bookings (Total)', 'Revenue (Month)', 'Revenue (Total)', 'Status', 'Action'].map(h => (
                      <th key={h} style={{ padding: '12px 10px', textAlign: 'left', fontSize: '11px', color: '#6B6F82', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {vendorRevenue.map(v => {
                    const bpm = Number(v.bookings_this_month);
                    const tier = bpm >= 16 ? 'pro' : bpm >= 6 ? 'growth' : 'free';
                    const tierColor = tier === 'pro' ? '#C9A84C' : tier === 'growth' ? '#A78BFA' : '#6B6F82';
                    return (
                      <tr key={v.id} style={{ borderBottom: '1px solid #252838' }}>
                        <td style={{ padding: '12px 10px', fontSize: '13px', fontWeight: 600 }}>{v.name}</td>
                        <td style={{ padding: '12px 10px', fontSize: '13px', color: '#9DA3B4' }}>{v.business_name || '—'}</td>
                        <td style={{ padding: '12px 10px' }}><span style={cs.badge(tierColor)}>{v.plan || 'free'}</span></td>
                        <td style={{ padding: '12px 10px', fontSize: '14px', fontWeight: 700, color: bpm >= 5 ? '#F59E0B' : '#E0E4F0' }}>{bpm} {bpm >= 5 && '⚡'}</td>
                        <td style={{ padding: '12px 10px', fontSize: '13px' }}>{v.total_bookings}</td>
                        <td style={{ padding: '12px 10px', fontSize: '13px', color: '#10B981', fontWeight: 600 }}>R{Number(v.revenue_this_month).toLocaleString()}</td>
                        <td style={{ padding: '12px 10px', fontSize: '13px' }}>R{Number(v.total_revenue).toLocaleString()}</td>
                        <td style={{ padding: '12px 10px' }}><span style={cs.badge(bpm >= 5 ? '#F59E0B' : '#10B981')}>{bpm >= 5 ? 'Premium Due' : 'Free Tier'}</span></td>
                        <td style={{ padding: '12px 10px' }}>
                          <select value={v.plan || 'free'} onChange={async e => { await api.put(`/admin/vendors/${v.id}/plan`, { plan: e.target.value }); loadTab(); }} style={{ ...cs.input, padding: '4px 8px', fontSize: '11px', width: '90px' }}>
                            <option value="free">Free</option>
                            <option value="growth">Growth</option>
                            <option value="pro">Pro</option>
                          </select>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            {vendorRevenue.length === 0 && <div style={{ ...cs.card, textAlign: 'center', padding: '40px', color: '#6B6F82' }}>No vendors yet.</div>}
          </>
        )}

        {/* GIFT CODES / AFFILIATE SYSTEM */}
        {tab === 'giftCodes' && (
          <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <div>
                <h3 style={{ fontSize: '18px', marginBottom: '4px' }}>Gift Purchase Codes</h3>
                <p style={{ fontSize: '13px', color: '#6B6F82' }}>Track affiliate codes for retail store purchases. Commission: 5% per redeemed code.</p>
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '12px', marginBottom: '20px' }}>
              <div style={{ ...cs.card, textAlign: 'center', padding: '20px' }}>
                <div style={{ fontSize: '24px', fontWeight: 700, color: '#E0E4F0' }}>{giftCodes.length}</div>
                <div style={{ fontSize: '11px', color: '#6B6F82' }}>Total Codes</div>
              </div>
              <div style={{ ...cs.card, textAlign: 'center', padding: '20px' }}>
                <div style={{ fontSize: '24px', fontWeight: 700, color: '#10B981' }}>{giftCodes.filter(c => c.status === 'redeemed').length}</div>
                <div style={{ fontSize: '11px', color: '#6B6F82' }}>Redeemed</div>
              </div>
              <div style={{ ...cs.card, textAlign: 'center', padding: '20px' }}>
                <div style={{ fontSize: '24px', fontWeight: 700, color: '#F59E0B' }}>{giftCodes.filter(c => c.status === 'generated').length}</div>
                <div style={{ fontSize: '11px', color: '#6B6F82' }}>Pending</div>
              </div>
              <div style={{ ...cs.card, textAlign: 'center', padding: '20px' }}>
                <div style={{ fontSize: '24px', fontWeight: 700, color: '#C9A84C' }}>R{giftCodes.filter(c => c.status === 'redeemed').reduce((a, c) => a + Number(c.commission_amount || 0), 0).toLocaleString()}</div>
                <div style={{ fontSize: '11px', color: '#6B6F82' }}>Commission Earned</div>
              </div>
            </div>
            {giftCodes.length > 0 ? (
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ borderBottom: '1px solid #252838' }}>
                      {['Code', 'Store', 'Gift', 'Amount', 'Commission', 'Buyer', 'Status', 'Date', 'Action'].map(h => (
                        <th key={h} style={{ padding: '10px 8px', textAlign: 'left', fontSize: '11px', color: '#6B6F82', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {giftCodes.map(c => (
                      <tr key={c.id} style={{ borderBottom: '1px solid #252838' }}>
                        <td style={{ padding: '10px 8px' }}><code style={{ background: '#1A1D2E', padding: '4px 8px', borderRadius: '6px', fontSize: '12px', color: '#C9A84C', fontWeight: 700 }}>{c.code}</code></td>
                        <td style={{ padding: '10px 8px', fontSize: '13px' }}>{c.store_name || '—'}</td>
                        <td style={{ padding: '10px 8px', fontSize: '13px', maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.gift_title || '—'}</td>
                        <td style={{ padding: '10px 8px', fontSize: '13px', fontWeight: 600 }}>R{Number(c.gift_amount || 0).toLocaleString()}</td>
                        <td style={{ padding: '10px 8px', fontSize: '13px', color: '#10B981', fontWeight: 600 }}>R{Number(c.commission_amount || 0).toLocaleString()}</td>
                        <td style={{ padding: '10px 8px', fontSize: '13px' }}>{c.buyer_name || '—'}</td>
                        <td style={{ padding: '10px 8px' }}><span style={cs.badge(c.status === 'redeemed' ? '#10B981' : '#F59E0B')}>{c.status}</span></td>
                        <td style={{ padding: '10px 8px', fontSize: '12px', color: '#6B6F82' }}>{new Date(c.created_at).toLocaleDateString('en-ZA')}</td>
                        <td style={{ padding: '10px 8px' }}>
                          {c.status === 'generated' && (
                            <button onClick={async () => { await api.post('/gift-codes/redeem', { code: c.code }); loadTab(); }} style={cs.btn('#10B981')} title="Mark as redeemed">✓ Redeem</button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : <div style={{ ...cs.card, textAlign: 'center', padding: '40px', color: '#6B6F82' }}>No gift codes generated yet. Codes are created when guests claim gifts from retail partners.</div>}
          </>
        )}

        {tab === 'sponsors' && (
          <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <div>
                <h3 style={{ fontSize: '18px', marginBottom: '4px' }}>Sponsor Management</h3>
                <p style={{ fontSize: '13px', color: '#6B6F82' }}>{sponsorsList.length}/10 ad slots filled &middot; Founding slot: {sponsorsList.find(s => s.tier === 'founding') ? 'Taken' : 'Available'}</p>
              </div>
              <button onClick={() => { setSponsorForm({ name: '', description: '', tagline: '', website: '', phone: '', email: '', category: '', tier: 'standard', slot_number: '', is_active: true }); setSponsorModal('new'); }} style={cs.btn('#A78BFA')}><FiPlus size={14} /> Add Sponsor</button>
            </div>

            <div style={{ display: 'grid', gap: '12px' }}>
              {sponsorsList.map(s => (
                <div key={s.id} style={{ ...cs.card, display: 'flex', alignItems: 'center', gap: '16px', padding: '16px 20px' }}>
                  <div style={{ width: '56px', height: '56px', borderRadius: '12px', overflow: 'hidden', flexShrink: 0, background: '#12141E', border: s.tier === 'founding' ? '2px solid #C9A84C' : '1px solid #252838' }}>
                    {s.logo ? <img src={s.logo} alt={s.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#6B6F82', fontSize: '20px' }}>{s.name[0]}</div>}
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                      <span style={{ fontWeight: 600, fontSize: '14px' }}>{s.name}</span>
                      <span style={cs.badge(s.tier === 'founding' ? '#C9A84C' : '#A78BFA')}>{s.tier}</span>
                      <span style={cs.badge(s.is_active ? '#10B981' : '#EF4444')}>{s.is_active ? 'active' : 'inactive'}</span>
                    </div>
                    <div style={{ fontSize: '12px', color: '#6B6F82' }}>
                      {s.category || 'No category'} &middot; Slot #{s.slot_number || '—'} &middot; {s.click_count || 0} clicks &middot; {s.impression_count || 0} impressions
                      {s.price_monthly > 0 && <span style={{ color: '#10B981', fontWeight: 600 }}> &middot; R{Number(s.price_monthly).toLocaleString()}/mo</span>}
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <button onClick={() => {
                      setSponsorForm({ name: s.name, description: s.description || '', tagline: s.tagline || '', website: s.website || '', phone: s.phone || '', email: s.email || '', category: s.category || '', tier: s.tier || 'standard', slot_number: s.slot_number || '', is_active: s.is_active });
                      setSponsorModal(s.id);
                    }} style={cs.btnOutline}><FiEdit size={14} /></button>
                    <button onClick={async () => {
                      if (!window.confirm(`Delete ${s.name}?`)) return;
                      await api.delete(`/admin/sponsors/${s.id}`);
                      loadTab();
                    }} style={cs.btnDanger}><FiTrash2 size={14} /></button>
                  </div>
                </div>
              ))}
              {sponsorsList.length === 0 && <div style={{ ...cs.card, textAlign: 'center', padding: '40px', color: '#6B6F82' }}>No sponsors yet. Add your first sponsor to get started.</div>}
            </div>
          </>
        )}

        {/* REVIEWS TAB */}
        {tab === 'reviews' && (
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
              <h3 style={{ margin: 0 }}>User Feedback & Reviews ({feedbackList.length})</h3>
              <span style={{ fontSize: '12px', color: '#6B6F82' }}>Approve feedback to show as public reviews on the website</span>
            </div>
            {feedbackList.length === 0 ? (
              <p style={{ textAlign: 'center', color: '#6B6F82', padding: '40px' }}>No feedback yet</p>
            ) : feedbackList.map(f => (
              <div key={f.id} style={{ ...cs.card, marginBottom: '12px', borderLeft: `3px solid ${f.approved ? '#10B981' : '#6B6F82'}` }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                      <strong style={{ color: '#E8EAF0' }}>{f.user_name}</strong>
                      <span style={{ fontSize: '11px', color: '#6B6F82' }}>{f.user_email}</span>
                      <span style={{ fontSize: '11px', padding: '2px 8px', borderRadius: '10px', background: f.category === 'bug' ? '#EF444420' : f.category === 'feature' ? '#3B82F620' : '#A78BFA20', color: f.category === 'bug' ? '#EF4444' : f.category === 'feature' ? '#3B82F6' : '#A78BFA' }}>{f.category}</span>
                      {f.approved && <span style={{ fontSize: '11px', padding: '2px 8px', borderRadius: '10px', background: '#10B98120', color: '#10B981' }}>✓ Public</span>}
                    </div>
                    <div style={{ marginBottom: '8px' }}>{'⭐'.repeat(f.rating || 5)}{'☆'.repeat(5 - (f.rating || 5))}</div>
                    <p style={{ margin: '0 0 8px', color: '#C8CAD4', fontSize: '14px', lineHeight: 1.6 }}>"{f.message}"</p>
                    <div style={{ fontSize: '11px', color: '#6B6F82' }}>{new Date(f.created_at).toLocaleDateString('en-ZA', { day: 'numeric', month: 'short', year: 'numeric' })}{f.page ? ` · Page: ${f.page}` : ''}</div>
                  </div>
                  <div style={{ display: 'flex', gap: '8px', flexShrink: 0 }}>
                    {!f.approved ? (
                      <button onClick={async () => { await api.put(`/admin/feedback/${f.id}/approve`, { approved: true }); const fb = await api.get('/admin/feedback'); setFeedbackList(fb.data); }} style={{ padding: '6px 14px', borderRadius: '8px', border: 'none', background: '#10B981', color: 'white', fontSize: '12px', cursor: 'pointer', fontWeight: 600 }}>
                        <FiCheck size={12} /> Approve
                      </button>
                    ) : (
                      <button onClick={async () => { await api.put(`/admin/feedback/${f.id}/approve`, { approved: false }); const fb = await api.get('/admin/feedback'); setFeedbackList(fb.data); }} style={{ padding: '6px 14px', borderRadius: '8px', border: 'none', background: '#EF444430', color: '#EF4444', fontSize: '12px', cursor: 'pointer', fontWeight: 600 }}>
                        <FiX size={12} /> Hide
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* KGATSO CLIENTS TAB */}
        {tab === 'kgatso' && (
          <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
              <h3 style={{ fontSize: '18px' }}>Kgatso Funeral Client Submissions ({kgatsoClients.length})</h3>
            </div>
            {kgatsoClients.length === 0 ? (
              <div style={{ ...cs.card, textAlign: 'center', padding: '40px', color: '#6B6F82' }}>No client submissions yet.</div>
            ) : kgatsoClients.map(c => (
              <div key={c.id} style={{ ...cs.card, padding: '0', overflow: 'hidden' }}>
                <div style={{ padding: '16px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }}
                  onClick={() => setKgatsoExpanded(kgatsoExpanded === c.id ? null : c.id)}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                    <div style={{ width: '42px', height: '42px', borderRadius: '10px', background: '#12141E', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px', color: '#C9A84C', border: '1px solid #252838' }}>
                      {c.deceased_name ? c.deceased_name[0]?.toUpperCase() : '?'}
                    </div>
                    <div>
                      <div style={{ fontWeight: 600, fontSize: '14px' }}>{c.deceased_name || 'Unnamed'}</div>
                      <div style={{ fontSize: '12px', color: '#6B6F82' }}>
                        {c.family_contact_1 || 'No contact'} &middot; {c.burial_date ? new Date(c.burial_date).toLocaleDateString('en-ZA') : 'No burial date'} &middot; Ref #{c.id}
                      </div>
                    </div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <select value={c.status} onClick={e => e.stopPropagation()} onChange={async e => {
                      await api.put(`/admin/kgatso-clients/${c.id}`, { status: e.target.value, admin_notes: c.admin_notes || '' });
                      loadTab();
                    }} style={{ ...cs.input, width: '120px', padding: '6px 10px', fontSize: '12px' }}>
                      <option value="new">New</option>
                      <option value="in_progress">In Progress</option>
                      <option value="completed">Completed</option>
                      <option value="cancelled">Cancelled</option>
                    </select>
                    <span style={cs.badge(c.status === 'completed' ? '#10B981' : c.status === 'in_progress' ? '#F59E0B' : c.status === 'cancelled' ? '#EF4444' : '#A78BFA')}>{c.status}</span>
                    <FiChevronDown size={16} style={{ color: '#6B6F82', transform: kgatsoExpanded === c.id ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }} />
                  </div>
                </div>
                {kgatsoExpanded === c.id && (
                  <div style={{ padding: '0 20px 20px', borderTop: '1px solid #252838' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', padding: '16px 0', fontSize: '13px' }}>
                      <div><span style={{ color: '#6B6F82' }}>ID Number:</span> {c.deceased_id || '—'}</div>
                      <div><span style={{ color: '#6B6F82' }}>Date of Death:</span> {c.date_of_death ? new Date(c.date_of_death).toLocaleDateString('en-ZA') : '—'}</div>
                      <div><span style={{ color: '#6B6F82' }}>Plan:</span> {c.plan || '—'}</div>
                      <div><span style={{ color: '#6B6F82' }}>Cemetery:</span> {c.cemetery || '—'}</div>
                      <div><span style={{ color: '#6B6F82' }}>Package Cost:</span> R{c.package_costs || '0'}</div>
                      <div><span style={{ color: '#6B6F82' }}>Contact 2:</span> {c.family_contact_2 || '—'}</div>
                      <div style={{ gridColumn: '1/-1' }}><span style={{ color: '#6B6F82' }}>Home Address:</span> {c.home_address || '—'}</div>
                      <div><span style={{ color: '#6B6F82' }}>Body From:</span> {c.body_collected_from || '—'}</div>
                      <div><span style={{ color: '#6B6F82' }}>Burial Time:</span> {c.burial_time || '—'}</div>
                      <div><span style={{ color: '#6B6F82' }}>Clothes:</span> {c.clothes || '—'}</div>
                      {c.route_home_to_church && <div><span style={{ color: '#6B6F82' }}>Route Home→Church:</span> {c.route_home_to_church}</div>}
                      {c.route_church_to_grave && <div><span style={{ color: '#6B6F82' }}>Route Church→Grave:</span> {c.route_church_to_grave}</div>}
                      {c.route_grave_to_home && <div><span style={{ color: '#6B6F82' }}>Route Grave→Home:</span> {c.route_grave_to_home}</div>}
                    </div>
                    {/* Checklist items */}
                    {c.checklist && Object.keys(c.checklist).length > 0 && (
                      <div style={{ marginBottom: '12px' }}>
                        <div style={{ fontSize: '12px', fontWeight: 700, color: '#C9A84C', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>At Home Checklist</div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                          {Object.entries(c.checklist).filter(([,v]) => v.needed === 'yes').map(([k, v]) => (
                            <span key={k} style={{ padding: '4px 10px', borderRadius: '6px', background: v.done ? '#10B98118' : '#F59E0B18', fontSize: '11px', color: v.done ? '#10B981' : '#F59E0B', fontWeight: 500 }}>
                              {v.done ? '✓ ' : ''}{k}{v.qty ? ` (x${v.qty})` : ''}{v.cost ? ` R${v.cost}` : ''}
                            </span>
                          ))}
                        </div>
                      </div>
                    )}
                    {c.graveside && Object.keys(c.graveside).length > 0 && (
                      <div style={{ marginBottom: '12px' }}>
                        <div style={{ fontSize: '12px', fontWeight: 700, color: '#C9A84C', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Graveside Items</div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                          {Object.entries(c.graveside).filter(([,v]) => v.needed === 'yes').map(([k, v]) => (
                            <span key={k} style={{ padding: '4px 10px', borderRadius: '6px', background: v.done ? '#10B98118' : '#F59E0B18', fontSize: '11px', color: v.done ? '#10B981' : '#F59E0B', fontWeight: 500 }}>
                              {v.done ? '✓ ' : ''}{k}{v.qty ? ` (x${v.qty})` : ''}{v.cost ? ` R${v.cost}` : ''}
                            </span>
                          ))}
                        </div>
                      </div>
                    )}
                    {c.notes && <div style={{ fontSize: '13px', color: '#8B8FA3', marginBottom: '12px' }}><span style={{ color: '#6B6F82', fontWeight: 600 }}>Client Notes:</span> {c.notes}</div>}
                    <div style={{ fontSize: '11px', color: '#6B6F82', marginBottom: '8px' }}>Submitted: {new Date(c.created_at).toLocaleString('en-ZA')}</div>
                    {c.family_contact_1 && (
                      <a href={`https://wa.me/${c.family_contact_1.replace(/\D/g, '')}?text=${encodeURIComponent(`Hi, this is Kgatso Funerals regarding the burial preparation for ${c.deceased_name}. Ref #${c.id}.`)}`}
                        target="_blank" rel="noopener noreferrer"
                        style={{ ...cs.btn('#25D366'), fontSize: '12px', marginTop: '4px' }}>WhatsApp Family Contact</a>
                    )}
                  </div>
                )}
              </div>
            ))}
          </>
        )}

        {/* UPLOADS TAB */}
        {tab === 'uploads' && (
          <>
            {/* Gallery Uploads */}
            <div style={cs.card}>
              <h4 style={{ marginBottom: '16px', fontSize: '15px', display: 'flex', alignItems: 'center', gap: '8px' }}><FiImage style={{ color: '#A78BFA' }} /> Event Gallery Uploads ({uploads.gallery?.length || 0})</h4>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: '12px' }}>
                {(uploads.gallery || []).map(g => (
                  <div key={g.id} style={{ background: '#12141E', borderRadius: '10px', overflow: 'hidden', border: '1px solid #252838' }}>
                    <div style={{ height: '140px', overflow: 'hidden' }}>
                      <img src={g.image_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={e => { e.target.style.display = 'none'; }} />
                    </div>
                    <div style={{ padding: '10px' }}>
                      <div style={{ fontSize: '12px', fontWeight: 600, color: '#E8EAF0', marginBottom: '4px' }}>{g.event_title}</div>
                      <div style={{ fontSize: '11px', color: '#6B6F82' }}>By: {g.guest_name || g.host_name}</div>
                      <div style={{ fontSize: '11px', color: '#6B6F82' }}>{ago(g.created_at)}</div>
                      {g.caption && <div style={{ fontSize: '11px', color: '#8B8FA3', marginTop: '4px' }}>{g.caption}</div>}
                      <span style={cs.badge(g.approved ? '#10B981' : '#F59E0B')}>{g.approved ? 'approved' : 'pending'}</span>
                    </div>
                  </div>
                ))}
              </div>
              {(!uploads.gallery || uploads.gallery.length === 0) && <p style={{ color: '#6B6F82', textAlign: 'center', padding: '30px' }}>No gallery uploads yet</p>}
            </div>

            {/* Proof of Payment Uploads */}
            <div style={cs.card}>
              <h4 style={{ marginBottom: '16px', fontSize: '15px', display: 'flex', alignItems: 'center', gap: '8px' }}><CoinIcon style={{ color: '#10B981' }} /> Proof of Payment Uploads ({uploads.proofs?.length || 0})</h4>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '12px' }}>
                {(uploads.proofs || []).map(p => (
                  <div key={p.id} style={{ background: '#12141E', borderRadius: '10px', overflow: 'hidden', border: '1px solid #252838' }}>
                    <div style={{ height: '160px', overflow: 'hidden', position: 'relative' }}>
                      {p.proof_of_payment?.match(/\.(jpg|jpeg|png|gif|webp)/i) ? (
                        <img src={p.proof_of_payment} alt="Proof" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      ) : (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#6B6F82' }}>
                          <a href={p.proof_of_payment} target="_blank" rel="noreferrer" style={{ color: '#60A5FA', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px', textDecoration: 'none' }}>
                            <FiExternalLink size={24} /> View File
                          </a>
                        </div>
                      )}
                    </div>
                    <div style={{ padding: '10px' }}>
                      <div style={{ fontSize: '12px', fontWeight: 600, color: '#E8EAF0' }}>{p.contributor_name}</div>
                      <div style={{ fontSize: '11px', color: '#6B6F82' }}>{p.gift_title} · {p.event_title}</div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '6px' }}>
                        <span style={cs.badge(p.payment_status === 'confirmed' ? '#10B981' : p.payment_status === 'submitted' ? '#60A5FA' : '#F59E0B')}>{p.payment_status}</span>
                        <span style={{ fontSize: '11px', color: '#6B6F82' }}>{ago(p.created_at)}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {(!uploads.proofs || uploads.proofs.length === 0) && <p style={{ color: '#6B6F82', textAlign: 'center', padding: '30px' }}>No proof of payment uploads</p>}
            </div>

            {/* Vendor Portfolio */}
            <div style={cs.card}>
              <h4 style={{ marginBottom: '16px', fontSize: '15px', display: 'flex', alignItems: 'center', gap: '8px' }}><HiOutlineBuildingStorefront style={{ color: '#818CF8' }} /> Vendor Portfolio Uploads ({uploads.portfolio?.length || 0})</h4>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: '12px' }}>
                {(uploads.portfolio || []).map(p => (
                  <div key={p.id} style={{ background: '#12141E', borderRadius: '10px', overflow: 'hidden', border: '1px solid #252838' }}>
                    <div style={{ height: '140px', overflow: 'hidden' }}>
                      {p.media_type === 'video' ? (
                        <video src={p.image_url} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      ) : (
                        <img src={p.image_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={e => { e.target.style.display = 'none'; }} />
                      )}
                    </div>
                    <div style={{ padding: '10px' }}>
                      <div style={{ fontSize: '12px', fontWeight: 600, color: '#E8EAF0' }}>{p.business_name || p.vendor_name}</div>
                      {p.caption && <div style={{ fontSize: '11px', color: '#8B8FA3' }}>{p.caption}</div>}
                      <div style={{ fontSize: '11px', color: '#6B6F82', marginTop: '2px' }}>{ago(p.created_at)}</div>
                      <button onClick={() => setNotifyModal(p.vendor_id)} style={{ ...cs.btnOutline, padding: '4px 8px', fontSize: '10px', marginTop: '6px' }}><FiSend size={10} /> Advise</button>
                    </div>
                  </div>
                ))}
              </div>
              {(!uploads.portfolio || uploads.portfolio.length === 0) && <p style={{ color: '#6B6F82', textAlign: 'center', padding: '30px' }}>No vendor portfolio uploads</p>}
            </div>
          </>
        )}

        {/* BANKING REVIEW TAB */}
        {tab === 'banking' && (
          <div style={cs.card}>
            <div style={{ padding: '14px', background: '#A78BFA10', borderRadius: '10px', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <FiShield size={18} style={{ color: '#A78BFA' }} />
              <div>
                <div style={{ fontSize: '14px', fontWeight: 600, color: '#A78BFA' }}>Banking Details Security Review</div>
                <div style={{ fontSize: '12px', color: '#8B8FA3' }}>Review banking details that hosts have added to their events. Flag suspicious or incorrect details.</div>
              </div>
            </div>
            <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '750px' }}>
              <thead>
                <tr>
                  <th style={cs.th}>Event</th>
                  <th style={cs.th}>Host</th>
                  <th style={cs.th}>Banking Details</th>
                  <th style={cs.th}>Contributions</th>
                  <th style={cs.th}>Total Amount</th>
                  <th style={cs.th}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filterList(bankingReview, ['title', 'host_name', 'host_email', 'bank_details']).map(b => (
                  <tr key={b.id}>
                    <td style={cs.td}><strong>{b.title}</strong></td>
                    <td style={cs.td}>
                      <div style={{ fontSize: '13px' }}>{b.host_name}</div>
                      <div style={{ fontSize: '11px', color: '#6B6F82' }}>{b.host_email}</div>
                      {b.host_phone && <div style={{ fontSize: '11px', color: '#6B6F82' }}><FiPhone size={10} /> {b.host_phone}</div>}
                    </td>
                    <td style={{ ...cs.td, maxWidth: '280px' }}>
                      <pre style={{ fontSize: '12px', color: '#8B8FA3', whiteSpace: 'pre-wrap', margin: 0, lineHeight: 1.6, fontFamily: 'Inter, sans-serif' }}>{b.bank_details}</pre>
                    </td>
                    <td style={cs.td}><span style={{ fontWeight: 700 }}>{b.contribution_count}</span></td>
                    <td style={cs.td}><span style={{ fontWeight: 700, color: '#10B981' }}>R{Number(b.total_amount).toLocaleString()}</span></td>
                    <td style={cs.td}>
                      <div style={{ display: 'flex', gap: '6px', flexDirection: 'column' }}>
                        <button onClick={async () => { await api.put(`/admin/banking-review/${b.id}/flag`, { flagged: false }); loadTab(); }} style={cs.btn('#10B981')}><FiCheck size={12} /> Verify</button>
                        <button onClick={async () => {
                          const note = window.prompt('Reason for flagging:');
                          if (note !== null) { await api.put(`/admin/banking-review/${b.id}/flag`, { flagged: true, note }); loadTab(); }
                        }} style={cs.btnDanger}><FiAlertTriangle size={12} /> Flag</button>
                        <button onClick={() => setNotifyModal(b.id)} style={cs.btnOutline}><FiSend size={12} /> Contact</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
            {bankingReview.length === 0 && <p style={{ textAlign: 'center', color: '#6B6F82', padding: '40px' }}>No events with banking details set</p>}
          </div>
        )}

        {/* PASSWORD RESET TAB */}
        {tab === 'passwords' && (
          <div style={cs.card}>
            <div style={{ padding: '14px', background: '#EF444410', borderRadius: '10px', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <FiLock size={18} style={{ color: '#EF4444' }} />
              <div>
                <div style={{ fontSize: '14px', fontWeight: 600, color: '#EF4444' }}>Password Recovery</div>
                <div style={{ fontSize: '12px', color: '#8B8FA3' }}>Reset passwords for users who have lost access. The user will be notified.</div>
              </div>
            </div>
            <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '650px' }}>
              <thead>
                <tr>
                  <th style={cs.th}>Name</th>
                  <th style={cs.th}>Email</th>
                  <th style={cs.th}>Role</th>
                  <th style={cs.th}>Joined</th>
                  <th style={cs.th}>Action</th>
                </tr>
              </thead>
              <tbody>
                {filterList(users, ['name', 'email', 'business_name']).map(u => (
                  <tr key={u.id}>
                    <td style={cs.td}><strong>{u.name}</strong>{u.business_name && <div style={{ fontSize: '11px', color: '#6B6F82' }}>{u.business_name}</div>}</td>
                    <td style={cs.td}>{u.email}</td>
                    <td style={cs.td}><span style={cs.badge(u.role === 'vendor' ? '#A78BFA' : '#60A5FA')}>{u.role}</span></td>
                    <td style={cs.td}><span style={{ fontSize: '12px', color: '#6B6F82' }}>{fmt(u.created_at)}</span></td>
                    <td style={cs.td}>
                      <button onClick={() => { setResetModal(u.id); setResetPassword(''); }} style={cs.btn('#F59E0B')}><FiLock size={12} /> Reset Password</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          </div>
        )}
      </div>

      {/* Password Reset Modal */}
      {resetModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, backdropFilter: 'blur(4px)' }} onClick={e => { if (e.target === e.currentTarget) setResetModal(null); }}>
          <div style={{ background: '#1A1D2B', borderRadius: '16px', padding: '28px', maxWidth: '400px', width: '100%', border: '1px solid #252838' }}>
            <h3 style={{ marginBottom: '8px', fontSize: '18px' }}><FiLock size={16} /> Reset Password</h3>
            <p style={{ fontSize: '13px', color: '#6B6F82', marginBottom: '16px' }}>The user will be notified that their password was reset.</p>
            <div style={{ marginBottom: '14px' }}>
              <label style={cs.label}>New Password</label>
              <input value={resetPassword} onChange={e => setResetPassword(e.target.value)} type="password" placeholder="Min 6 characters" style={cs.input} />
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button onClick={() => setResetModal(null)} style={cs.btnOutline}>Cancel</button>
              <button onClick={async () => {
                if (resetPassword.length < 6) { alert('Password must be at least 6 characters'); return; }
                await api.post('/admin/reset-password', { user_id: resetModal, new_password: resetPassword });
                setResetModal(null);
                alert('Password has been reset and user has been notified.');
              }} style={cs.btn('#F59E0B')}><FiCheck size={14} /> Reset Password</button>
            </div>
          </div>
        </div>
      )}

      {/* Sponsor Modal */}
      {sponsorModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, backdropFilter: 'blur(4px)' }} onClick={e => { if (e.target === e.currentTarget) setSponsorModal(null); }}>
          <div style={{ background: '#1A1D2B', borderRadius: '16px', padding: '28px', maxWidth: '540px', width: '100%', border: '1px solid #252838', maxHeight: '90vh', overflowY: 'auto' }}>
            <h3 style={{ marginBottom: '20px', fontSize: '18px' }}>{sponsorModal === 'new' ? 'Add New Sponsor' : 'Edit Sponsor'}</h3>
            <div style={{ display: 'grid', gap: '14px' }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
                <div><label style={cs.label}>Sponsor Name</label><input value={sponsorForm.name} onChange={e => setSponsorForm({ ...sponsorForm, name: e.target.value })} placeholder="e.g., Kgatso Funerals" style={cs.input} /></div>
                <div><label style={cs.label}>Category</label><input value={sponsorForm.category} onChange={e => setSponsorForm({ ...sponsorForm, category: e.target.value })} placeholder="e.g., Funeral Services" style={cs.input} /></div>
              </div>
              <div><label style={cs.label}>Tagline</label><input value={sponsorForm.tagline} onChange={e => setSponsorForm({ ...sponsorForm, tagline: e.target.value })} placeholder="e.g., Comforting You In Difficulties" style={cs.input} /></div>
              <div><label style={cs.label}>Description</label><textarea value={sponsorForm.description} onChange={e => setSponsorForm({ ...sponsorForm, description: e.target.value })} rows={3} style={{ ...cs.input, resize: 'vertical' }} /></div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
                <div><label style={cs.label}>Website</label><input value={sponsorForm.website} onChange={e => setSponsorForm({ ...sponsorForm, website: e.target.value })} placeholder="https://..." style={cs.input} /></div>
                <div><label style={cs.label}>Phone</label><input value={sponsorForm.phone} onChange={e => setSponsorForm({ ...sponsorForm, phone: e.target.value })} style={cs.input} /></div>
              </div>
              <div><label style={cs.label}>Email</label><input value={sponsorForm.email} onChange={e => setSponsorForm({ ...sponsorForm, email: e.target.value })} style={cs.input} /></div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '14px' }}>
                <div>
                  <label style={cs.label}>Tier</label>
                  <select value={sponsorForm.tier} onChange={e => setSponsorForm({ ...sponsorForm, tier: e.target.value })} style={cs.input}>
                    <option value="founding">Founding Partner</option>
                    <option value="premium">Premium</option>
                    <option value="standard">Standard</option>
                  </select>
                </div>
                <div><label style={cs.label}>Slot #</label><input type="number" value={sponsorForm.slot_number} onChange={e => setSponsorForm({ ...sponsorForm, slot_number: e.target.value })} placeholder="1-10" style={cs.input} /></div>
                <div>
                  <label style={cs.label}>Status</label>
                  <select value={sponsorForm.is_active ? 'true' : 'false'} onChange={e => setSponsorForm({ ...sponsorForm, is_active: e.target.value === 'true' })} style={cs.input}>
                    <option value="true">Active</option>
                    <option value="false">Inactive</option>
                  </select>
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
                <div>
                  <label style={cs.label}>Logo</label>
                  <input type="file" accept="image/*" onChange={e => setSponsorForm({ ...sponsorForm, logoFile: e.target.files[0] })} style={{ ...cs.input, padding: '8px' }} />
                </div>
                <div>
                  <label style={cs.label}>Banner</label>
                  <input type="file" accept="image/*" onChange={e => setSponsorForm({ ...sponsorForm, bannerFile: e.target.files[0] })} style={{ ...cs.input, padding: '8px' }} />
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
              <button onClick={() => setSponsorModal(null)} style={cs.btnOutline}>Cancel</button>
              <button onClick={async () => {
                const fd = new FormData();
                Object.entries(sponsorForm).forEach(([k, v]) => {
                  if (k === 'logoFile' || k === 'bannerFile') return;
                  fd.append(k, v);
                });
                if (sponsorForm.logoFile) fd.append('logo', sponsorForm.logoFile);
                if (sponsorForm.bannerFile) fd.append('banner', sponsorForm.bannerFile);
                try {
                  if (sponsorModal === 'new') {
                    await api.post('/admin/sponsors', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
                  } else {
                    await api.put(`/admin/sponsors/${sponsorModal}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
                  }
                  setSponsorModal(null);
                  loadTab();
                } catch(e) { alert('Failed: ' + (e.response?.data?.error || e.message)); }
              }} disabled={!sponsorForm.name} style={{ ...cs.btn('#A78BFA'), opacity: !sponsorForm.name ? 0.5 : 1 }}><FiCheck size={14} /> {sponsorModal === 'new' ? 'Create Sponsor' : 'Save Changes'}</button>
            </div>
          </div>
        </div>
      )}

      {tab === 'payouts' && (
        <div>
          <h3 style={{ fontSize: '18px', marginBottom: '20px' }}>Withdrawal Requests</h3>
          {[
            { title: 'Host Withdrawals', data: payoutsData.host_withdrawals || [], type: 'host' },
            { title: 'Vendor Withdrawals', data: payoutsData.vendor_withdrawals || [], type: 'vendor' }
          ].map(section => (
            <div key={section.type} style={{ marginBottom: '32px' }}>
              <h4 style={{ fontSize: '15px', marginBottom: '12px', color: '#A78BFA' }}>{section.title}</h4>
              {section.data.length === 0 ? (
                <div style={{ padding: '20px', textAlign: 'center', color: '#6B6F82', background: '#1A1D2B', borderRadius: '12px' }}>No withdrawal requests</div>
              ) : (
                <div style={{ display: 'grid', gap: '8px' }}>
                  {section.data.map(wr => (
                    <div key={wr.id} style={{ background: '#1A1D2B', borderRadius: '12px', padding: '16px', border: '1px solid #252838' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '8px' }}>
                        <div>
                          <div style={{ fontWeight: 600, fontSize: '14px' }}>{wr.name} ({wr.email})</div>
                          <div style={{ fontSize: '12px', color: '#6B6F82', marginTop: '4px' }}>
                            {wr.bank_name && <>{wr.bank_name} &bull; {wr.account_holder} &bull; ****{(wr.account_number||'').slice(-4)} &bull; Branch: {wr.branch_code}</>}
                            {!wr.bank_name && <span style={{ color: '#EF4444' }}>No banking details on file</span>}
                          </div>
                          <div style={{ fontSize: '11px', color: '#6B6F82', marginTop: '2px' }}>
                            Requested: {new Date(wr.created_at).toLocaleDateString('en-ZA', { day: 'numeric', month: 'short', year: 'numeric' })}
                            {wr.processed_at && <> &bull; Processed: {new Date(wr.processed_at).toLocaleDateString('en-ZA', { day: 'numeric', month: 'short', year: 'numeric' })}</>}
                          </div>
                        </div>
                        <div style={{ textAlign: 'right' }}>
                          <div style={{ fontSize: '20px', fontWeight: 700, color: '#10B981' }}>R{Number(wr.amount).toLocaleString()}</div>
                          <span style={{
                            display: 'inline-block', padding: '2px 8px', borderRadius: '6px', fontSize: '11px', fontWeight: 600, marginTop: '4px',
                            background: wr.status === 'pending' ? 'rgba(245,158,11,0.15)' : wr.status === 'processed' ? 'rgba(16,185,129,0.15)' : 'rgba(239,68,68,0.15)',
                            color: wr.status === 'pending' ? '#F59E0B' : wr.status === 'processed' ? '#10B981' : '#EF4444'
                          }}>{wr.status}</span>
                        </div>
                      </div>
                      {wr.status === 'pending' && (
                        <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
                          <button onClick={async () => {
                            try {
                              await api.put(`/admin/withdrawals/${wr.id}`, { status: 'processed', type: section.type });
                              loadTab();
                            } catch { alert('Failed'); }
                          }} style={{ padding: '6px 14px', borderRadius: '8px', border: 'none', background: '#10B981', color: 'white', cursor: 'pointer', fontSize: '12px', fontWeight: 600 }}>
                            <FiCheck size={12} /> Mark as Paid
                          </button>
                          <button onClick={async () => {
                            const reason = prompt('Rejection reason (optional):');
                            try {
                              await api.put(`/admin/withdrawals/${wr.id}`, { status: 'rejected', admin_notes: reason || '', type: section.type });
                              loadTab();
                            } catch { alert('Failed'); }
                          }} style={{ padding: '6px 14px', borderRadius: '8px', border: '1px solid #374151', background: 'transparent', color: '#EF4444', cursor: 'pointer', fontSize: '12px', fontWeight: 600 }}>
                            <FiX size={12} /> Reject
                          </button>
                        </div>
                      )}
                      {wr.admin_notes && <div style={{ marginTop: '8px', fontSize: '12px', color: '#6B6F82', fontStyle: 'italic' }}>Note: {wr.admin_notes}</div>}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* AI Design Analytics */}
      {tab === 'aiDesign' && (
        <div>
          <h2 style={{ fontSize: isMobile ? '20px' : '24px', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}><FiZap /> AI Invitation Designer Analytics</h2>
          {!aiAnalytics ? (
            <p style={{ color: '#888' }}>Loading analytics...</p>
          ) : (
            <>
              {/* Summary Cards */}
              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(4, 1fr)', gap: '14px', marginBottom: '28px' }}>
                {[
                  { label: 'Total Generations', value: aiAnalytics.total_generations, color: '#E3425C', icon: '🎨' },
                  { label: 'Downloads', value: aiAnalytics.total_downloads, color: '#3B82F6', icon: '📥' },
                  { label: 'Used as Invitation', value: aiAnalytics.total_uses_as_invitation, color: '#10B981', icon: '✅' },
                  { label: 'Unique Users', value: aiAnalytics.unique_users, color: '#A78BFA', icon: '👤' },
                ].map((card, i) => (
                  <div key={i} style={{
                    background: '#1A1D2B', borderRadius: '14px', padding: '20px',
                    border: '1px solid #252838',
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                      <span style={{ fontSize: '22px' }}>{card.icon}</span>
                      <span style={{ color: card.color, fontSize: '28px', fontWeight: 800 }}>{card.value}</span>
                    </div>
                    <div style={{ color: '#888', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>{card.label}</div>
                  </div>
                ))}
              </div>

              {/* Cost estimate */}
              <div style={{
                background: 'linear-gradient(135deg, #1A1D2B, #252838)', borderRadius: '14px', padding: '20px',
                border: '1px solid #252838', marginBottom: '28px',
                display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px',
              }}>
                <div>
                  <div style={{ color: '#888', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', marginBottom: '4px' }}>Estimated API Cost (if paid)</div>
                  <div style={{ fontSize: '22px', fontWeight: 800, color: '#F59E0B' }}>
                    ${(aiAnalytics.total_generations * 0.04).toFixed(2)} <span style={{ fontSize: '14px', color: '#888', fontWeight: 400 }}>(R{(aiAnalytics.total_generations * 0.04 * 17.5).toFixed(0)})</span>
                  </div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ color: '#888', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', marginBottom: '4px' }}>Cost Per Invitation</div>
                  <div style={{ fontSize: '16px', fontWeight: 600, color: '#10B981' }}>~R0.70 each</div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ color: '#888', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase', marginBottom: '4px' }}>Conversion Rate</div>
                  <div style={{ fontSize: '16px', fontWeight: 600, color: '#3B82F6' }}>
                    {aiAnalytics.total_generations > 0 ? ((aiAnalytics.total_uses_as_invitation / aiAnalytics.total_generations) * 100).toFixed(0) : 0}%
                  </div>
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '20px', marginBottom: '28px' }}>
                {/* Top Themes */}
                <div style={{ background: '#1A1D2B', borderRadius: '14px', padding: '20px', border: '1px solid #252838' }}>
                  <h3 style={{ fontSize: '16px', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>🎯 Top Themes</h3>
                  {aiAnalytics.top_themes?.length === 0 ? (
                    <p style={{ color: '#555', fontSize: '13px' }}>No data yet</p>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                      {aiAnalytics.top_themes?.map((t, i) => {
                        const maxCount = aiAnalytics.top_themes[0]?.count || 1;
                        return (
                          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <span style={{ fontSize: '12px', color: '#888', width: '20px', textAlign: 'right' }}>#{i + 1}</span>
                            <div style={{ flex: 1 }}>
                              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '3px' }}>
                                <span style={{ fontSize: '13px', fontWeight: 600 }}>{t.theme_keyword}</span>
                                <span style={{ fontSize: '12px', color: '#E3425C', fontWeight: 700 }}>{t.count}</span>
                              </div>
                              <div style={{ height: '4px', borderRadius: '2px', background: '#252838' }}>
                                <div style={{ height: '100%', borderRadius: '2px', background: '#E3425C', width: `${(t.count / maxCount) * 100}%`, transition: 'width 0.5s' }} />
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>

                {/* Top Event Types */}
                <div style={{ background: '#1A1D2B', borderRadius: '14px', padding: '20px', border: '1px solid #252838' }}>
                  <h3 style={{ fontSize: '16px', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>📊 Top Event Types</h3>
                  {aiAnalytics.top_event_types?.length === 0 ? (
                    <p style={{ color: '#555', fontSize: '13px' }}>No data yet</p>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                      {aiAnalytics.top_event_types?.map((t, i) => {
                        const maxCount = aiAnalytics.top_event_types[0]?.count || 1;
                        return (
                          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <span style={{ fontSize: '12px', color: '#888', width: '20px', textAlign: 'right' }}>#{i + 1}</span>
                            <div style={{ flex: 1 }}>
                              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '3px' }}>
                                <span style={{ fontSize: '13px', fontWeight: 600 }}>{t.event_type}</span>
                                <span style={{ fontSize: '12px', color: '#3B82F6', fontWeight: 700 }}>{t.count}</span>
                              </div>
                              <div style={{ height: '4px', borderRadius: '2px', background: '#252838' }}>
                                <div style={{ height: '100%', borderRadius: '2px', background: '#3B82F6', width: `${(t.count / maxCount) * 100}%`, transition: 'width 0.5s' }} />
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>

              {/* Daily Activity */}
              <div style={{ background: '#1A1D2B', borderRadius: '14px', padding: '20px', border: '1px solid #252838' }}>
                <h3 style={{ fontSize: '16px', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>📈 Daily Activity (Last 30 Days)</h3>
                {aiAnalytics.daily_stats?.length === 0 ? (
                  <p style={{ color: '#555', fontSize: '13px' }}>No data yet</p>
                ) : (
                  <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                      <thead>
                        <tr style={{ borderBottom: '1px solid #252838' }}>
                          <th style={{ padding: '10px 12px', textAlign: 'left', color: '#888', fontWeight: 600 }}>Date</th>
                          <th style={{ padding: '10px 12px', textAlign: 'left', color: '#888', fontWeight: 600 }}>Action</th>
                          <th style={{ padding: '10px 12px', textAlign: 'right', color: '#888', fontWeight: 600 }}>Count</th>
                        </tr>
                      </thead>
                      <tbody>
                        {aiAnalytics.daily_stats?.map((row, i) => (
                          <tr key={i} style={{ borderBottom: '1px solid #1E2030' }}>
                            <td style={{ padding: '10px 12px', color: '#ccc' }}>{new Date(row.date).toLocaleDateString('en-ZA', { day: 'numeric', month: 'short' })}</td>
                            <td style={{ padding: '10px 12px' }}>
                              <span style={{
                                padding: '3px 10px', borderRadius: '12px', fontSize: '11px', fontWeight: 600,
                                background: row.action === 'generate' ? 'rgba(227,66,92,0.15)' : row.action === 'download' ? 'rgba(59,130,246,0.15)' : row.action === 'use_as_invitation' ? 'rgba(16,185,129,0.15)' : 'rgba(255,255,255,0.08)',
                                color: row.action === 'generate' ? '#E3425C' : row.action === 'download' ? '#3B82F6' : row.action === 'use_as_invitation' ? '#10B981' : '#888',
                              }}>
                                {row.action === 'generate' ? 'Generated' : row.action === 'download' ? 'Downloaded' : row.action === 'use_as_invitation' ? 'Used' : row.action}
                              </span>
                            </td>
                            <td style={{ padding: '10px 12px', textAlign: 'right', fontWeight: 700, color: '#fff' }}>{row.count}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      )}

      {/* GUESTS & RSVPs TAB */}
      {tab === 'guests' && (
        <div>
          <p style={{ color: '#6B6F82', fontSize: '13px', marginBottom: '20px' }}>{guestsList.length} total guests across all events</p>

          {/* RSVP summary cards */}
          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(4, 1fr)', gap: '12px', marginBottom: '20px' }}>
            {[
              { label: 'Total Guests', value: guestsList.length, color: '#A78BFA' },
              { label: 'Attending', value: guestsList.filter(g => g.rsvp_status === 'attending').length, color: '#10B981' },
              { label: 'Maybe', value: guestsList.filter(g => g.rsvp_status === 'maybe').length, color: '#F59E0B' },
              { label: 'Not Attending', value: guestsList.filter(g => g.rsvp_status === 'not_attending').length, color: '#EF4444' },
            ].map((s, i) => (
              <div key={i} style={{ background: '#1A1D2B', borderRadius: '12px', padding: '16px', border: '1px solid #252838', textAlign: 'center' }}>
                <div style={{ fontSize: '26px', fontWeight: 800, color: s.color }}>{s.value}</div>
                <div style={{ fontSize: '11px', color: '#6B6F82', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', marginTop: '4px' }}>{s.label}</div>
              </div>
            ))}
          </div>

          {/* Search */}
          <div style={{ position: 'relative', marginBottom: '16px' }}>
            <FiSearch style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#6B6F82' }} />
            <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search by name, phone, email, event..." style={{ ...cs.input, paddingLeft: '36px' }} />
          </div>

          <div style={cs.card}>
            <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '700px' }}>
                <thead>
                  <tr>
                    <th style={cs.th}>Guest</th>
                    <th style={cs.th}>Contact</th>
                    <th style={cs.th}>RSVP</th>
                    <th style={cs.th}>Event</th>
                    <th style={cs.th}>Host</th>
                    <th style={cs.th}>Date Added</th>
                  </tr>
                </thead>
                <tbody>
                  {guestsList.filter(g => {
                    if (!search) return true;
                    const s = search.toLowerCase();
                    return (g.name || '').toLowerCase().includes(s) || (g.phone || '').toLowerCase().includes(s) || (g.email || '').toLowerCase().includes(s) || (g.event_title || '').toLowerCase().includes(s) || (g.host_name || '').toLowerCase().includes(s);
                  }).map(g => (
                    <tr key={g.id}>
                      <td style={cs.td}>
                        <div style={{ fontWeight: 600, fontSize: '13px' }}>{g.name || '—'}</div>
                        {g.dietary_requirements && <div style={{ fontSize: '10px', color: '#F59E0B' }}>Diet: {g.dietary_requirements}</div>}
                      </td>
                      <td style={cs.td}>
                        {g.phone && <div style={{ fontSize: '12px' }}><FiPhone size={10} /> {g.phone}</div>}
                        {g.email && <div style={{ fontSize: '11px', color: '#6B6F82' }}><FiMail size={10} /> {g.email}</div>}
                      </td>
                      <td style={cs.td}>
                        <span style={{
                          padding: '3px 10px', borderRadius: '12px', fontSize: '11px', fontWeight: 600,
                          background: g.rsvp_status === 'attending' ? 'rgba(16,185,129,0.15)' : g.rsvp_status === 'maybe' ? 'rgba(245,158,11,0.15)' : g.rsvp_status === 'not_attending' ? 'rgba(239,68,68,0.15)' : 'rgba(255,255,255,0.08)',
                          color: g.rsvp_status === 'attending' ? '#10B981' : g.rsvp_status === 'maybe' ? '#F59E0B' : g.rsvp_status === 'not_attending' ? '#EF4444' : '#6B6F82',
                        }}>
                          {g.rsvp_status === 'attending' ? 'Attending' : g.rsvp_status === 'maybe' ? 'Maybe' : g.rsvp_status === 'not_attending' ? 'Not Attending' : g.rsvp_status || 'Pending'}
                        </span>
                      </td>
                      <td style={cs.td}>
                        <div style={{ fontSize: '12px', fontWeight: 500 }}>{g.event_title}</div>
                        <div style={{ fontSize: '10px', color: '#6B6F82' }}>{g.event_type}{g.event_date ? ` · ${new Date(g.event_date).toLocaleDateString('en-ZA', { day: 'numeric', month: 'short' })}` : ''}</div>
                      </td>
                      <td style={cs.td}><span style={{ fontSize: '12px', color: '#8B8FA3' }}>{g.host_name}</span></td>
                      <td style={cs.td}><span style={{ fontSize: '12px', color: '#6B6F82' }}>{fmt(g.created_at)}</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* TRACTION & GROWTH TAB — investor-ready metrics */}
      {tab === 'traction' && (
        <div>
          <p style={{ color: '#6B6F82', fontSize: '13px', marginBottom: '20px' }}>Platform metrics for investor deck & funding applications</p>

          {!tractionData ? (
            <p style={{ color: '#888' }}>Loading traction data...</p>
          ) : (
            <>
              {/* Hero metrics */}
              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(4, 1fr)', gap: '14px', marginBottom: '28px' }}>
                {[
                  { label: 'Registered Users', value: tractionData.summary.total_users, color: '#A78BFA', icon: '👥' },
                  { label: 'Events Created', value: tractionData.summary.total_events, color: '#60A5FA', icon: '📅' },
                  { label: 'Total Guests Reached', value: tractionData.summary.total_guests, color: '#F472B6', icon: '🎯' },
                  { label: 'Invitations Sent', value: tractionData.summary.total_invitations, color: '#10B981', icon: '💌' },
                  { label: 'AI Designs Generated', value: tractionData.summary.total_ai_designs, color: '#E3425C', icon: '🎨' },
                  { label: 'WhatsApp Messages', value: tractionData.summary.total_messages_sent, color: '#25D366', icon: '💬' },
                  { label: 'Gift Contributions', value: tractionData.summary.total_contributions, color: '#F59E0B', icon: '🎁', sub: `R${tractionData.summary.contribution_value?.toLocaleString()} value` },
                  { label: 'Repeat Users', value: tractionData.summary.repeat_users, color: '#8B5CF6', icon: '🔄', sub: 'Created 2+ events' },
                ].map((s, i) => (
                  <div key={i} style={{ background: '#1A1D2B', borderRadius: '14px', padding: '18px', border: '1px solid #252838', position: 'relative' }}>
                    <div style={{ fontSize: '20px', marginBottom: '6px' }}>{s.icon}</div>
                    <div style={{ fontSize: '28px', fontWeight: 800, color: s.color }}>{s.value?.toLocaleString()}</div>
                    <div style={{ fontSize: '11px', color: '#6B6F82', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', marginTop: '2px' }}>{s.label}</div>
                    {s.sub && <div style={{ fontSize: '10px', color: '#4ADE80', marginTop: '4px' }}>{s.sub}</div>}
                  </div>
                ))}
              </div>

              {/* Growth indicator */}
              <div style={{ background: 'linear-gradient(135deg, #1A1D2B, #252838)', borderRadius: '14px', padding: '20px', border: '1px solid #252838', marginBottom: '28px', display: 'flex', flexWrap: 'wrap', gap: '24px' }}>
                <div>
                  <div style={{ color: '#6B6F82', fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', marginBottom: '4px' }}>Weekly Signups</div>
                  <div style={{ fontSize: '24px', fontWeight: 800, color: '#4ADE80' }}>+{tractionData.summary.weekly_signups}</div>
                </div>
                <div>
                  <div style={{ color: '#6B6F82', fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', marginBottom: '4px' }}>Monthly Signups</div>
                  <div style={{ fontSize: '24px', fontWeight: 800, color: '#60A5FA' }}>+{tractionData.summary.monthly_signups}</div>
                </div>
                <div>
                  <div style={{ color: '#6B6F82', fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', marginBottom: '4px' }}>Avg Guests / Event</div>
                  <div style={{ fontSize: '24px', fontWeight: 800, color: '#F472B6' }}>{tractionData.summary.avg_guests_per_event}</div>
                </div>
                <div>
                  <div style={{ color: '#6B6F82', fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', marginBottom: '4px' }}>Total People Touched</div>
                  <div style={{ fontSize: '24px', fontWeight: 800, color: '#A78BFA' }}>{(tractionData.summary.total_users + tractionData.summary.total_guests).toLocaleString()}</div>
                  <div style={{ fontSize: '10px', color: '#6B6F82' }}>users + guests</div>
                </div>
              </div>

              {/* Feature adoption */}
              <div style={{ background: '#1A1D2B', borderRadius: '14px', padding: '20px', border: '1px solid #252838', marginBottom: '28px' }}>
                <h3 style={{ fontSize: '16px', marginBottom: '16px' }}>Feature Adoption</h3>
                <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(3, 1fr)', gap: '12px' }}>
                  {[
                    { label: 'Gift Registry Items', value: tractionData.feature_adoption.gift_registry, color: '#F59E0B' },
                    { label: 'Timeline Items', value: tractionData.feature_adoption.timeline, color: '#60A5FA' },
                    { label: 'Checklist Items', value: tractionData.feature_adoption.checklist, color: '#10B981' },
                    { label: 'Budget Items', value: tractionData.feature_adoption.budget, color: '#A78BFA' },
                    { label: 'Vision Boards', value: tractionData.feature_adoption.vision_boards, color: '#F472B6' },
                    { label: 'AI Designs', value: tractionData.feature_adoption.ai_designs, color: '#E3425C' },
                  ].map((f, i) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px', borderRadius: '10px', background: '#252838' }}>
                      <div style={{ fontSize: '22px', fontWeight: 800, color: f.color, minWidth: '50px' }}>{f.value}</div>
                      <div style={{ fontSize: '12px', color: '#8B8FA3', fontWeight: 500 }}>{f.label}</div>
                    </div>
                  ))}
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '20px', marginBottom: '28px' }}>
                {/* Event types breakdown */}
                <div style={{ background: '#1A1D2B', borderRadius: '14px', padding: '20px', border: '1px solid #252838' }}>
                  <h3 style={{ fontSize: '16px', marginBottom: '16px' }}>Event Types</h3>
                  {tractionData.breakdown.event_types?.map((t, i) => {
                    const maxCnt = tractionData.breakdown.event_types[0]?.cnt || 1;
                    return (
                      <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                        <div style={{ flex: 1 }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '3px' }}>
                            <span style={{ fontSize: '13px', fontWeight: 600 }}>{t.event_type || 'Other'}</span>
                            <span style={{ fontSize: '12px', color: '#60A5FA', fontWeight: 700 }}>{t.cnt}</span>
                          </div>
                          <div style={{ height: '4px', borderRadius: '2px', background: '#252838' }}>
                            <div style={{ height: '100%', borderRadius: '2px', background: '#60A5FA', width: `${(t.cnt / maxCnt) * 100}%`, transition: 'width 0.5s' }} />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                {/* RSVP breakdown */}
                <div style={{ background: '#1A1D2B', borderRadius: '14px', padding: '20px', border: '1px solid #252838' }}>
                  <h3 style={{ fontSize: '16px', marginBottom: '16px' }}>RSVP Responses</h3>
                  {tractionData.breakdown.rsvp_status?.map((r, i) => {
                    const colors = { attending: '#10B981', maybe: '#F59E0B', not_attending: '#EF4444', pending: '#6B6F82' };
                    const labels = { attending: 'Attending', maybe: 'Maybe', not_attending: 'Not Attending', pending: 'Pending' };
                    const maxCnt = tractionData.breakdown.rsvp_status[0]?.cnt || 1;
                    return (
                      <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                        <div style={{ flex: 1 }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '3px' }}>
                            <span style={{ fontSize: '13px', fontWeight: 600 }}>{labels[r.rsvp_status] || r.rsvp_status}</span>
                            <span style={{ fontSize: '12px', color: colors[r.rsvp_status] || '#888', fontWeight: 700 }}>{r.cnt}</span>
                          </div>
                          <div style={{ height: '4px', borderRadius: '2px', background: '#252838' }}>
                            <div style={{ height: '100%', borderRadius: '2px', background: colors[r.rsvp_status] || '#888', width: `${(r.cnt / maxCnt) * 100}%`, transition: 'width 0.5s' }} />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Monthly growth chart (text-based) */}
              <div style={{ background: '#1A1D2B', borderRadius: '14px', padding: '20px', border: '1px solid #252838' }}>
                <h3 style={{ fontSize: '16px', marginBottom: '16px' }}>Monthly Growth</h3>
                <div style={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                    <thead>
                      <tr style={{ borderBottom: '1px solid #252838' }}>
                        <th style={{ padding: '10px 12px', textAlign: 'left', color: '#6B6F82', fontWeight: 600 }}>Month</th>
                        <th style={{ padding: '10px 12px', textAlign: 'right', color: '#A78BFA', fontWeight: 600 }}>Users</th>
                        <th style={{ padding: '10px 12px', textAlign: 'right', color: '#60A5FA', fontWeight: 600 }}>Events</th>
                        <th style={{ padding: '10px 12px', textAlign: 'right', color: '#F472B6', fontWeight: 600 }}>Guests</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(() => {
                        const months = new Set([
                          ...tractionData.growth.users_by_month.map(r => r.month),
                          ...tractionData.growth.events_by_month.map(r => r.month),
                          ...tractionData.growth.guests_by_month.map(r => r.month),
                        ]);
                        return [...months].sort().map((m, i) => {
                          const u = tractionData.growth.users_by_month.find(r => r.month === m)?.cnt || 0;
                          const e = tractionData.growth.events_by_month.find(r => r.month === m)?.cnt || 0;
                          const g = tractionData.growth.guests_by_month.find(r => r.month === m)?.cnt || 0;
                          const [yr, mo] = m.split('-');
                          const label = new Date(yr, mo - 1).toLocaleDateString('en-ZA', { month: 'short', year: 'numeric' });
                          return (
                            <tr key={i} style={{ borderBottom: '1px solid #1E2030' }}>
                              <td style={{ padding: '10px 12px', color: '#ccc', fontWeight: 500 }}>{label}</td>
                              <td style={{ padding: '10px 12px', textAlign: 'right', fontWeight: 700, color: '#A78BFA' }}>+{u}</td>
                              <td style={{ padding: '10px 12px', textAlign: 'right', fontWeight: 700, color: '#60A5FA' }}>+{e}</td>
                              <td style={{ padding: '10px 12px', textAlign: 'right', fontWeight: 700, color: '#F472B6' }}>+{g}</td>
                            </tr>
                          );
                        });
                      })()}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          )}
        </div>
      )}

      {/* Invoices Tab */}
      {tab === 'serviceRequests' && (() => {
        const payClr = (s) => s === 'paid' ? '#34D399' : s === 'pending' ? '#F59E0B' : '#8B8FA3';
        const statClr = (s) => s === 'new' ? '#60A5FA' : s === 'in_progress' ? '#F59E0B' : s === 'delivered' ? '#34D399' : '#8B8FA3';
        return (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
            <h2 style={{ margin: 0 }}>AI Event Media Package — Requests</h2>
            <button className="btn btn-sm btn-secondary" onClick={loadTab}><FiActivity size={12} /> Refresh</button>
          </div>
          {serviceRequests.length === 0 && <div style={{ textAlign: 'center', padding: '40px', color: '#6B6F82' }}>No service requests yet. When a host requests the R400 AI Event Media Package, it appears here.</div>}
          {serviceRequests.map(sr => (
            <div key={sr.id} style={{ background: 'var(--card, #fff)', borderRadius: '12px', padding: '16px', marginBottom: '12px', border: '1px solid var(--border, #eee)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '8px' }}>
                <div>
                  <strong>#{sr.id} — {sr.event_name || sr.event_title || 'Event'}</strong>
                  <div style={{ fontSize: '13px', color: '#6B6F82', marginTop: '2px' }}>
                    {sr.user_name} · {sr.contact_phone || 'no phone'} · {sr.contact_email}
                    {sr.event_date ? ` · ${String(sr.event_date).slice(0, 10)}` : ''}
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                  <span style={{ fontSize: '11px', fontWeight: 700, padding: '3px 10px', borderRadius: '12px', background: payClr(sr.payment_status) + '22', color: payClr(sr.payment_status) }}>{sr.payment_status === 'paid' ? 'PAID R400' : sr.payment_status.toUpperCase()}</span>
                  <span style={{ fontSize: '11px', fontWeight: 700, padding: '3px 10px', borderRadius: '12px', background: statClr(sr.status) + '22', color: statClr(sr.status) }}>{sr.status.toUpperCase()}</span>
                </div>
              </div>
              {sr.style_preferences && <div style={{ fontSize: '13px', marginTop: '8px' }}><strong style={{ fontSize: '11px', color: '#6B6F82', textTransform: 'uppercase' }}>Style:</strong> {sr.style_preferences}</div>}
              {sr.notes && <div style={{ fontSize: '13px', marginTop: '4px' }}><strong style={{ fontSize: '11px', color: '#6B6F82', textTransform: 'uppercase' }}>Notes:</strong> {sr.notes}</div>}
              {Array.isArray(sr.photos) && sr.photos.length > 0 && (
                <div style={{ display: 'flex', gap: '8px', marginTop: '10px', flexWrap: 'wrap' }}>
                  {sr.photos.map((p, i) => <img key={i} src={p} alt="photo" style={{ width: '64px', height: '64px', objectFit: 'cover', borderRadius: '8px', border: '1px solid #eee' }} />)}
                </div>
              )}
              <div style={{ display: 'flex', gap: '8px', marginTop: '12px', flexWrap: 'wrap' }}>
                {['new', 'in_progress', 'delivered'].map(s => (
                  <button key={s} onClick={async () => { try { await api.put('/admin/service-requests/' + sr.id, { status: s }); loadTab(); } catch (e) { alert(e.response?.data?.error || 'Failed'); } }} style={{ padding: '5px 12px', borderRadius: '8px', border: 'none', fontSize: '11px', fontWeight: 700, cursor: 'pointer', background: statClr(s) + '18', color: statClr(s), opacity: sr.status === s ? 1 : 0.55 }}>{s === 'new' ? 'New' : s === 'in_progress' ? 'In Progress' : 'Delivered'}</button>
                ))}
                {sr.contact_phone && (() => { const d = (sr.contact_phone || '').replace(/\D/g, ''); const intl = d.startsWith('0') ? '27' + d.slice(1) : (d.startsWith('27') ? d : '27' + d); return (
                  <button onClick={() => window.open('https://wa.me/' + intl + '?text=' + encodeURIComponent('Hi ' + (sr.user_name || '') + ', this is Grand Gather Registry! Your AI Event Media Package request #' + sr.id + ' is confirmed. Let us get started on your AI video invitation, invitations, welcome board and programme!'), '_blank')} style={{ padding: '5px 12px', borderRadius: '8px', border: 'none', fontSize: '11px', fontWeight: 700, cursor: 'pointer', background: '#25D36618', color: '#25D366' }}>WhatsApp Host</button>
                ); })()}
              </div>
            </div>
          ))}
        </div>
        );
      })()}
      {tab === 'invoices' && (() => {
        const openInv = (inv) => { const w = window.open('about:blank'); setTimeout(() => { w.location.href = '/api/invoices/' + inv.id + '/view'; }, 100); };
        const copyInvLink = (inv) => { navigator.clipboard.writeText('https://grandgatherregistry.co.za/api/invoices/' + inv.id + '/view'); alert('Invoice link copied!'); };
        const totalRevenue = invoices.reduce((s, i) => s + (Number(i.total) || 0), 0);
        const statusClr = (s) => s === 'paid' ? '#34D399' : s === 'pending_payment' ? '#F59E0B' : s === 'sent' ? '#60A5FA' : s === 'draft' ? '#8B8FA3' : '#EF4444';
        const saveInvoice = async () => {
          try {
            const body = { ...invForm, banking_details: invForm.banking_details || {}, items: invForm.items.filter(it => it.description.trim()) };
            body.subtotal = body.items.reduce((s, it) => s + (it.quantity || 0) * (it.unit_price || 0), 0);
            body.total = body.subtotal;
            if (invModal === 'new') {
              const r = await api.post('/invoices', body);
              setInvoices([r.data, ...invoices]);
            } else {
              const r = await api.put('/invoices/' + invModal, body);
              setInvoices(invoices.map(i => i.id === invModal ? r.data : i));
            }
            setInvModal(null);
            setInvForm({ client_name: '', client_email: '', client_phone: '', host_name: '', from_name: 'Grand Gather Registry', from_email: 'info@grandgatherregistry.co.za', from_phone: '+27 61 391 1942', banking_details: { bank: 'FNB', account_holder: 'Grand Gather Registry (PTY) LTD', account_number: '63218677285', branch_code: '252945', swift: 'FIRNZAJJ' }, due_date: '', billing_type: 'once_off', recur_until: '', notes: '', items: [{ description: '', quantity: 1, unit_price: 0 }] });
            api.get('/admin/invoices').then(r2 => setInvoices(r2.data));
          } catch (e) { alert('Failed: ' + (e.response?.data?.error || e.message)); }
        };
        const startEdit = (inv) => {
          const items = (inv.items && inv.items.length > 0) ? inv.items.map(it => ({ description: it.description || '', quantity: it.quantity || 1, unit_price: it.unit_price || 0 })) : [{ description: '', quantity: 1, unit_price: 0 }];
          setInvForm({ client_name: inv.client_name || '', client_email: inv.client_email || '', client_phone: inv.client_phone || '', host_name: inv.host_name || '', from_name: inv.from_name || 'Grand Gather Registry', from_email: inv.from_email || 'info@grandgatherregistry.co.za', from_phone: inv.from_phone || '+27 61 391 1942', banking_details: inv.banking_details || { bank: 'FNB', account_holder: 'Grand Gather Registry (PTY) LTD', account_number: '63218677285', branch_code: '252945', swift: 'FIRNZAJJ' }, due_date: inv.due_date ? String(inv.due_date).slice(0, 10) : '', billing_type: inv.billing_type || 'once_off', recur_until: inv.recur_until ? String(inv.recur_until).slice(0, 10) : '', notes: inv.notes || '', items });
          setInvModal(inv.id);
        };
        const handleStatusChange = async (inv, newStatus) => {
          try {
            await api.put('/invoices/' + inv.id, { ...inv, items: inv.items, status: newStatus });
            setInvoices(invoices.map(i => i.id === inv.id ? { ...i, status: newStatus } : i));
          } catch (e) { alert('Failed: ' + (e.response?.data?.error || e.message)); }
        };
        // Invoice form helpers
        const updateItem = (idx, field, val) => { const items = [...invForm.items]; items[idx] = { ...items[idx], [field]: field === 'description' ? val : Number(val) || 0 }; if (field === 'quantity' || field === 'unit_price') items[idx].total = (items[idx].quantity || 0) * (items[idx].unit_price || 0); else items[idx].total = (items[idx].quantity || 0) * (items[idx].unit_price || 0); setInvForm({ ...invForm, items }); };
        const addItem = () => setInvForm({ ...invForm, items: [...invForm.items, { description: '', quantity: 1, unit_price: 0 }] });
        const removeItem = (idx) => setInvForm({ ...invForm, items: invForm.items.filter((_, i) => i !== idx) });
        const calcInvTotal = () => invForm.items.reduce((s, it) => s + (it.quantity || 0) * (it.unit_price || 0), 0);
        const INV_PRESETS = [
          { label: 'Custom digital invitation design (incl. 2 revisions)', price: 250 },
          { label: 'RSVP coordination & follow-ups (up to 2 reminder rounds)', price: 150 },
          { label: 'Invitation + RSVP coordination package', price: 400 },
          { label: 'Gift registry setup & management', price: 200 },
          { label: 'Event programme / running order design', price: 150 },
          { label: 'Thank-you card design', price: 100 },
        ];
        const addPreset = (val) => {
          if (val === '' || val === undefined) return;
          const p = INV_PRESETS[Number(val)];
          if (!p) return;
          const items = [...invForm.items];
          const emptyIdx = items.findIndex(it => !it.description.trim());
          if (emptyIdx >= 0) items[emptyIdx] = { description: p.label, quantity: 1, unit_price: p.price };
          else items.push({ description: p.label, quantity: 1, unit_price: p.price });
          setInvForm({ ...invForm, items });
        };
        return (
          <div style={{ position: 'relative' }}>
            {/* Watermark gift box logo */}
            <div style={{ position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <img src="/ggr-logo-circle.png" alt="" style={{ width: 'min(50vw, 400px)', opacity: 0.04, filter: 'grayscale(100%)' }} />
            </div>
            <div style={{ position: 'relative', zIndex: 1 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '12px' }}>
                <div>
                  <h3 style={{ fontSize: '16px', fontWeight: 700, color: '#E8EAF0', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <FiFileText size={18} style={{ color: '#E3425C' }} /> Invoice CRM
                  </h3>
                  <p style={{ fontSize: '12px', color: '#6B6F82', marginTop: '4px' }}>Create, manage & send branded invoices to clients</p>
                </div>
                <button onClick={() => setInvModal('new')} style={{ padding: '10px 20px', borderRadius: '10px', border: 'none', background: '#E3425C', color: '#fff', fontWeight: 700, fontSize: '13px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', whiteSpace: 'nowrap' }}><FiPlus size={14} /> New Invoice</button>
              </div>
              {/* Summary Cards */}
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))', gap: '10px', marginBottom: '20px' }}>
                {[{ label: 'Total Invoices', value: invoices.length, color: '#E3425C' }, { label: 'Total Revenue', value: 'R' + totalRevenue.toLocaleString(), color: '#34D399' }, { label: 'Paid', value: invoices.filter(i => i.status === 'paid').length, color: '#34D399' }, { label: 'Sent', value: invoices.filter(i => i.status === 'sent').length, color: '#60A5FA' }, { label: 'Pending POP', value: invoices.filter(i => i.status === 'pending_payment').length, color: '#F59E0B' }, { label: 'Drafts', value: invoices.filter(i => i.status === 'draft').length, color: '#8B8FA3' }].map((s, i) => (
                  <div key={i} style={{ background: '#1E2030', borderRadius: '10px', padding: '14px', textAlign: 'center', border: '1px solid ' + s.color + '20' }}>
                    <div style={{ fontSize: '22px', fontWeight: 800, color: s.color, marginBottom: '2px' }}>{typeof s.value === 'number' ? s.value.toLocaleString() : s.value}</div>
                    <div style={{ fontSize: '10px', color: '#6B6F82', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>{s.label}</div>
                  </div>
                ))}
              </div>
              {/* Invoices Table */}
              <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '700px' }}>
                  <thead>
                    <tr>
                      <th style={cs.th}>Invoice #</th>
                      <th style={cs.th}>Client</th>
                      <th style={cs.th}>Created By</th>
                      <th style={cs.th}>Date</th>
                      <th style={cs.th}>Total</th>
                      <th style={cs.th}>Status</th>
                      <th style={cs.th}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoices.map((inv, i) => (
                      <tr key={i} style={{ borderBottom: '1px solid #1E2030' }}>
                        <td style={{ ...cs.td, fontWeight: 600, color: '#E3425C', fontFamily: 'monospace' }}>{inv.invoice_number}{inv.billing_type === 'monthly' && <span style={{ marginLeft: '6px', background: '#8B5CF618', color: '#8B5CF6', fontSize: '9px', fontWeight: 700, padding: '2px 6px', borderRadius: '8px', textTransform: 'uppercase', fontFamily: 'inherit' }}>Recurring</span>}</td>
                        <td style={cs.td}>{inv.client_name}</td>
                        <td style={cs.td}>{inv.user_name || '—'}</td>
                        <td style={cs.td}>{inv.created_at ? new Date(inv.created_at).toLocaleDateString('en-ZA') : '—'}</td>
                        <td style={{ ...cs.td, fontWeight: 600, color: '#34D399' }}>R{Number(inv.total || 0).toLocaleString()}</td>
                        <td style={cs.td}>
                          <select value={inv.status} onChange={e => handleStatusChange(inv, e.target.value)}
                            style={{ padding: '4px 8px', borderRadius: '6px', border: '1px solid ' + statusClr(inv.status) + '40', background: statusClr(inv.status) + '18', color: statusClr(inv.status), fontSize: '11px', fontWeight: 700, cursor: 'pointer', textTransform: 'uppercase' }}>
                            <option value="draft">Draft</option>
                            <option value="sent">Sent</option>
                            <option value="pending_payment">Pending POP</option>
                            <option value="paid">Paid</option>
                          </select>
                        </td>
                        <td style={cs.td}>
                          <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                            <button onClick={() => startEdit(inv)} title="Edit" style={{ padding: '4px 8px', borderRadius: '6px', border: 'none', background: '#F59E0B18', color: '#F59E0B', cursor: 'pointer', fontSize: '11px', fontWeight: 600 }}><FiEdit size={12} /></button>
                            <button onClick={() => openInv(inv)} title="View" style={{ padding: '4px 8px', borderRadius: '6px', border: 'none', background: '#E3425C18', color: '#E3425C', cursor: 'pointer', fontSize: '11px', fontWeight: 600 }}><FiEye size={12} /></button>
                            {inv.client_email && inv.status !== 'paid' && <button onClick={async () => { try { await api.post('/invoices/' + inv.id + '/send'); alert('Invoice sent to ' + inv.client_email); loadTab(); } catch(e) { alert(e.response?.data?.error || 'Failed'); } }} title="Email Invoice" style={{ padding: '4px 8px', borderRadius: '6px', border: 'none', background: '#60A5FA18', color: '#60A5FA', cursor: 'pointer', fontSize: '11px', fontWeight: 600 }}><FiSend size={12} /></button>}
                            {inv.client_phone && <button onClick={() => { const digits = (inv.client_phone || '').replace(/\D/g, ''); const intl = digits.startsWith('0') ? '27' + digits.slice(1) : (digits.startsWith('27') ? digits : '27' + digits); const link = 'https://grandgatherregistry.co.za/api/invoices/' + inv.id + '/view'; const msg = 'Hi ' + (inv.client_name || '') + ', here is your invoice ' + inv.invoice_number + ' from Grand Gather Registry (PTY) LTD. You can view & pay securely here: ' + link + ' (EFT or instant Ozow payment). Thank you!'; window.open('https://wa.me/' + intl + '?text=' + encodeURIComponent(msg), '_blank'); }} title="Send via WhatsApp" style={{ padding: '4px 8px', borderRadius: '6px', border: 'none', background: '#25D36618', color: '#25D366', cursor: 'pointer', fontSize: '11px', fontWeight: 600 }}><FiMessageSquare size={12} /></button>}
                            {inv.status === 'pending_payment' && inv.proof_of_payment && <button onClick={() => window.open('/api/invoices/proof/' + inv.proof_of_payment, '_blank')} title="View Proof of Payment" style={{ padding: '4px 8px', borderRadius: '6px', border: 'none', background: '#F59E0B18', color: '#F59E0B', cursor: 'pointer', fontSize: '11px', fontWeight: 600 }}><FiImage size={12} /></button>}
                            {inv.status === 'pending_payment' && <button onClick={async () => { const method = prompt('Payment method (eft/cash/paystack):', 'eft'); if (!method) return; try { await api.put('/invoices/' + inv.id + '/mark-paid', { payment_method: method }); loadTab(); } catch(e) { alert(e.response?.data?.error || 'Failed'); } }} title="Mark as Paid" style={{ padding: '4px 8px', borderRadius: '6px', border: 'none', background: '#34D39918', color: '#34D399', cursor: 'pointer', fontSize: '11px', fontWeight: 600 }}><FiCheck size={12} /></button>}
                            {inv.status === 'paid' && <button onClick={() => window.open('/api/invoices/' + inv.id + '/receipt', '_blank')} title="View Receipt" style={{ padding: '4px 8px', borderRadius: '6px', border: 'none', background: '#34D39918', color: '#34D399', cursor: 'pointer', fontSize: '11px', fontWeight: 600 }}><FiFileText size={12} /></button>}
                            <button onClick={() => copyInvLink(inv)} title="Copy Link" style={{ padding: '4px 8px', borderRadius: '6px', border: 'none', background: '#8B8FA318', color: '#8B8FA3', cursor: 'pointer', fontSize: '11px', fontWeight: 600 }}><FiCopy size={12} /></button>
                            <button onClick={async () => { if (!window.confirm('Delete invoice ' + inv.invoice_number + '? This cannot be undone.')) return; try { await api.delete('/invoices/' + inv.id); loadTab(); } catch(e) { alert(e.response?.data?.error || 'Failed to delete'); } }} title="Delete" style={{ padding: '4px 8px', borderRadius: '6px', border: 'none', background: '#EF444418', color: '#EF4444', cursor: 'pointer', fontSize: '11px', fontWeight: 600 }}><FiTrash2 size={12} /></button>
                          </div>
                        </td>
                      </tr>
                    ))}
                    {invoices.length === 0 && (
                      <tr><td colSpan={7} style={{ ...cs.td, textAlign: 'center', color: '#6B6F82', padding: '40px' }}>
                        <div style={{ fontSize: '36px', marginBottom: '8px', opacity: 0.3 }}><FiFileText size={40} style={{ margin: '0 auto' }} /></div>
                        No invoices yet. Click "New Invoice" to create your first one.
                      </td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            {/* Create / Edit Invoice Modal */}
            {invModal && (
              <>
                <div onClick={() => setInvModal(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 999 }} />
                <div style={{ position: 'fixed', inset: '40px', background: '#151720', borderRadius: '16px', zIndex: 1000, maxWidth: '620px', margin: '0 auto', overflowY: 'auto', padding: '24px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <h3 style={{ fontSize: '16px', fontWeight: 700, color: '#E8EAF0' }}>{invModal === 'new' ? 'New Invoice' : 'Edit Invoice'}</h3>
                    <button onClick={() => setInvModal(null)} style={{ background: 'none', border: 'none', color: '#6B6F82', cursor: 'pointer', fontSize: '20px' }}><FiX /></button>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '16px' }}>
                    {[
                      ['Client Name', 'client_name'],
                      ['Client Email', 'client_email'],
                      ['Client Phone', 'client_phone'],
                      ['Event / Host Name', 'host_name'],
                      ['From (Business)', 'from_name'],
                      ['From Email', 'from_email'],
                      ['From Phone', 'from_phone'],
                    ].map(([label, key]) => (
                      <div key={key}>
                        <div style={{ fontSize: '11px', color: '#6B6F82', marginBottom: '4px', textTransform: 'uppercase', fontWeight: 600 }}>{label}</div>
                        <input value={invForm[key]} onChange={e => setInvForm({ ...invForm, [key]: e.target.value })} style={{ width: '100%', padding: '8px 10px', borderRadius: '8px', border: '1px solid #2A2D3A', background: '#1E2030', color: '#E8EAF0', fontSize: '13px' }} />
                      </div>
                    ))}
                  </div>
                  <div style={{ marginBottom: '16px' }}>
                    <div style={{ fontSize: '11px', color: '#6B6F82', marginBottom: '4px', textTransform: 'uppercase', fontWeight: 600 }}>Payment Due Date</div>
                    <input type="date" value={invForm.due_date || ''} onChange={e => setInvForm({ ...invForm, due_date: e.target.value })} style={{ width: '100%', padding: '8px 10px', borderRadius: '8px', border: '1px solid #2A2D3A', background: '#1E2030', color: '#E8EAF0', fontSize: '13px' }} />
                  </div>
                  <div style={{ marginBottom: '16px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                    <div>
                      <div style={{ fontSize: '11px', color: '#6B6F82', marginBottom: '4px', textTransform: 'uppercase', fontWeight: 600 }}>Billing Type</div>
                      <select value={invForm.billing_type || 'once_off'} onChange={e => setInvForm({ ...invForm, billing_type: e.target.value })} style={{ width: '100%', padding: '8px 10px', borderRadius: '8px', border: '1px solid #2A2D3A', background: '#1E2030', color: '#E8EAF0', fontSize: '13px' }}>
                        <option value="once_off">Once-off</option>
                        <option value="monthly">Recurring (monthly)</option>
                      </select>
                    </div>
                    {(invForm.billing_type === 'monthly') && (
                      <div>
                        <div style={{ fontSize: '11px', color: '#6B6F82', marginBottom: '4px', textTransform: 'uppercase', fontWeight: 600 }}>Repeat Until (optional)</div>
                        <input type="date" value={invForm.recur_until || ''} onChange={e => setInvForm({ ...invForm, recur_until: e.target.value })} style={{ width: '100%', padding: '8px 10px', borderRadius: '8px', border: '1px solid #2A2D3A', background: '#1E2030', color: '#E8EAF0', fontSize: '13px' }} />
                      </div>
                    )}
                  </div>
                  <div style={{ fontSize: '12px', fontWeight: 700, color: '#E8EAF0', marginBottom: '8px' }}>Line Items</div>
                  <select value="" onChange={e => addPreset(e.target.value)} style={{ width: '100%', padding: '8px 10px', borderRadius: '8px', border: '1px solid #2A2D3A', background: '#1E2030', color: '#E8EAF0', fontSize: '13px', marginBottom: '10px', cursor: 'pointer' }}>
                    <option value="">⚡ Quick add a service…</option>
                    {INV_PRESETS.map((p, i) => <option key={i} value={i}>{p.label} — R{p.price}</option>)}
                  </select>
                  {invForm.items.map((it, idx) => (
                    <div key={idx} style={{ display: 'flex', gap: '8px', marginBottom: '8px', alignItems: 'center' }}>
                      <input placeholder="Description" value={it.description} onChange={e => updateItem(idx, 'description', e.target.value)} style={{ flex: 1, padding: '8px 10px', borderRadius: '8px', border: '1px solid #2A2D3A', background: '#1E2030', color: '#E8EAF0', fontSize: '13px' }} />
                      <input type="number" placeholder="Qty" value={it.quantity} onChange={e => updateItem(idx, 'quantity', e.target.value)} style={{ width: '55px', padding: '8px 6px', borderRadius: '8px', border: '1px solid #2A2D3A', background: '#1E2030', color: '#E8EAF0', fontSize: '13px', textAlign: 'center' }} />
                      <div style={{ position: 'relative', width: '100px' }}>
                        <span style={{ position: 'absolute', left: '8px', top: '50%', transform: 'translateY(-50%)', color: '#6B6F82', fontSize: '13px' }}>R</span>
                        <input type="number" placeholder="0" value={it.unit_price} onChange={e => updateItem(idx, 'unit_price', e.target.value)} style={{ width: '100%', padding: '8px 6px 8px 22px', borderRadius: '8px', border: '1px solid #2A2D3A', background: '#1E2030', color: '#E8EAF0', fontSize: '13px', textAlign: 'right' }} />
                      </div>
                      <div style={{ width: '80px', textAlign: 'right', color: '#34D399', fontSize: '13px', fontWeight: 600 }}>R{((it.quantity || 0) * (it.unit_price || 0)).toFixed(2)}</div>
                      <button onClick={() => removeItem(idx)} style={{ background: 'none', border: 'none', color: '#EF4444', cursor: 'pointer', padding: '4px' }}><FiTrash2 size={14} /></button>
                    </div>
                  ))}
                  <button onClick={addItem} style={{ padding: '6px 12px', borderRadius: '6px', border: '1px dashed #2A2D3A', background: 'none', color: '#6B6F82', cursor: 'pointer', fontSize: '12px', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '4px' }}><FiPlus size={12} /> Add Item</button>
                  <div style={{ textAlign: 'right', marginBottom: '16px', fontSize: '15px', fontWeight: 700, color: '#E3425C' }}>Total: R{calcInvTotal().toFixed(2)}</div>
                  <div style={{ marginBottom: '16px' }}>
                    <div style={{ fontSize: '11px', color: '#6B6F82', marginBottom: '4px', textTransform: 'uppercase', fontWeight: 600 }}>Notes</div>
                    <textarea value={invForm.notes} onChange={e => setInvForm({ ...invForm, notes: e.target.value })} rows={2} style={{ width: '100%', padding: '8px 10px', borderRadius: '8px', border: '1px solid #2A2D3A', background: '#1E2030', color: '#E8EAF0', fontSize: '13px', resize: 'vertical' }} />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                    <button onClick={() => setInvModal(null)} style={{ padding: '10px 20px', borderRadius: '10px', border: '1px solid #2A2D3A', background: 'none', color: '#6B6F82', cursor: 'pointer', fontSize: '13px', fontWeight: 600 }}>Cancel</button>
                    <button onClick={saveInvoice} style={{ padding: '10px 20px', borderRadius: '10px', border: 'none', background: '#E3425C', color: '#fff', cursor: 'pointer', fontSize: '13px', fontWeight: 700, display: 'flex', alignItems: 'center', gap: '6px' }}><FiFileText size={14} /> {invModal === 'new' ? 'Create Invoice' : 'Update Invoice'}</button>
                  </div>
                </div>
              </>
            )}
          </div>
        );
      })()}

      {/* Staff & Roles Tab */}
      {tab === 'staff' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '12px' }}>
            <div>
              <h3 style={{ fontSize: '16px', fontWeight: 700, color: '#E8EAF0', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <FiUsers size={18} style={{ color: '#E3425C' }} /> Staff & Roles
              </h3>
              <p style={{ fontSize: '12px', color: '#6B6F82', marginTop: '4px' }}>Invite team members with restricted access to specific admin sections</p>
            </div>
          </div>
          {/* Invite Form */}
          <div style={{ background: '#1E2030', borderRadius: '12px', padding: '20px', marginBottom: '24px' }}>
            <h4 style={{ fontSize: '14px', fontWeight: 700, color: '#E8EAF0', marginBottom: '16px' }}>Invite Staff Member</h4>
            <div style={{ display: 'flex', gap: '8px', marginBottom: '12px', flexWrap: 'wrap' }}>
              <input placeholder="Email address of registered user" value={inviteEmail} onChange={e => setInviteEmail(e.target.value)} style={{ flex: 1, minWidth: '200px', padding: '8px 12px', borderRadius: '8px', border: '1px solid #2A2D3A', background: '#151720', color: '#E8EAF0', fontSize: '13px' }} />
              <button onClick={async () => {
                if (!inviteEmail.trim()) return alert('Enter an email');
                try {
                  await api.post('/admin/staff/invite', { email: inviteEmail, permissions: invitePerms });
                  setInviteEmail(''); setInvitePerms([]);
                  const r = await api.get('/admin/staff'); setAdminStaff(r.data);
                  alert('Staff added!');
                } catch(e) { alert(e.response?.data?.error || 'Failed'); }
              }} style={{ padding: '8px 20px', borderRadius: '8px', border: 'none', background: '#E3425C', color: '#fff', fontWeight: 700, cursor: 'pointer', fontSize: '13px', whiteSpace: 'nowrap' }}>Add Staff</button>
            </div>
            <div style={{ fontSize: '11px', color: '#6B6F82', marginBottom: '8px', textTransform: 'uppercase', fontWeight: 600 }}>Permissions (select which tabs they can access)</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
              {TABS.map(t => t.key !== 'staff' && (
                <label key={t.key} style={{ display: 'flex', alignItems: 'center', gap: '4px', padding: '4px 10px', borderRadius: '6px', border: '1px solid ' + (invitePerms.includes(t.key) ? '#E3425C' : '#2A2D3A'), background: invitePerms.includes(t.key) ? '#E3425C18' : 'transparent', cursor: 'pointer', fontSize: '12px', color: invitePerms.includes(t.key) ? '#E3425C' : '#6B6F82' }}>
                  <input type="checkbox" checked={invitePerms.includes(t.key)} onChange={e => setInvitePerms(e.target.checked ? [...invitePerms, t.key] : invitePerms.filter(k => k !== t.key))} style={{ display: 'none' }} />
                  {t.label}
                </label>
              ))}
            </div>
          </div>
          {/* Staff List */}
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '600px' }}>
              <thead><tr>
                <th style={cs.th}>Name</th><th style={cs.th}>Email</th><th style={cs.th}>Permissions</th><th style={cs.th}>Added By</th><th style={cs.th}>Actions</th>
              </tr></thead>
              <tbody>
                {adminStaff.map((s, i) => (
                  <tr key={i} style={{ borderBottom: '1px solid #1E2030' }}>
                    <td style={{ ...cs.td, fontWeight: 600, color: '#E8EAF0' }}>{s.name}</td>
                    <td style={cs.td}>{s.email}</td>
                    <td style={cs.td}>
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                        {(s.permissions || []).map(p => {
                          const tab = TABS.find(t => t.key === p);
                          return <span key={p} style={{ padding: '2px 8px', borderRadius: '4px', background: '#E3425C18', color: '#E3425C', fontSize: '10px', fontWeight: 600 }}>{tab?.label || p}</span>;
                        })}
                        {(!s.permissions || s.permissions.length === 0) && <span style={{ color: '#F59E0B', fontSize: '11px' }}>All access</span>}
                      </div>
                    </td>
                    <td style={cs.td}>{s.invited_by_name || '—'}</td>
                    <td style={cs.td}>
                      <button onClick={async () => {
                        if (!confirm('Remove ' + s.name + ' from staff?')) return;
                        await api.delete('/admin/staff/' + s.id);
                        setAdminStaff(adminStaff.filter(x => x.id !== s.id));
                      }} style={{ padding: '4px 10px', borderRadius: '6px', border: 'none', background: '#EF444418', color: '#EF4444', cursor: 'pointer', fontSize: '11px', fontWeight: 600 }}>Remove</button>
                    </td>
                  </tr>
                ))}
                {adminStaff.length === 0 && (
                  <tr><td colSpan={5} style={{ ...cs.td, textAlign: 'center', color: '#6B6F82', padding: '40px' }}>No staff members yet. Invite someone above.</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* KYC Verification Tab */}
      {tab === 'kyc' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <div>
              <h3 style={{ fontSize: '18px', margin: 0 }}>KYC Verification</h3>
              <p style={{ fontSize: '13px', color: '#6B6F82', margin: '4px 0 0 0' }}>
                {kycPending.length} pending review{kycPending.length !== 1 ? 's' : ''}
              </p>
            </div>
          </div>

          {kycPending.length === 0 ? (
            <div style={{ ...cs.card, textAlign: 'center', padding: '60px 40px', color: '#6B6F82' }}>
              <FiShield size={48} style={{ marginBottom: '16px', opacity: 0.3 }} />
              <p style={{ fontSize: '16px', fontWeight: 600, marginBottom: '8px', color: '#C8CAD4' }}>No Pending Verifications</p>
              <p style={{ fontSize: '13px' }}>All KYC documents have been reviewed.</p>
            </div>
          ) : (
            <div style={{ display: 'grid', gap: '12px' }}>
              {kycPending.map(k => (
                <div key={k.id} style={{ ...cs.card, display: 'flex', alignItems: 'flex-start', gap: '16px', padding: '20px' }}>
                  {/* User avatar */}
                  <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: '#12141E', border: '2px solid #252838', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', fontWeight: 700, color: '#A78BFA', flexShrink: 0 }}>
                    {k.name ? k.name[0].toUpperCase() : '?'}
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px', flexWrap: 'wrap' }}>
                      <strong style={{ color: '#E8EAF0', fontSize: '15px' }}>{k.name}</strong>
                      <span style={{ fontSize: '12px', color: '#6B6F82' }}>{k.email}</span>
                      <span style={cs.badge(k.role === 'vendor' ? '#F59E0B' : '#3B82F6')}>{k.role}</span>
                      <span style={cs.badge('#F59E0B')}>pending</span>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '8px', fontSize: '13px', color: '#C8CAD4', marginBottom: '12px' }}>
                      {k.id_number && (
                        <div>
                          <span style={{ color: '#6B6F82', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>ID Number</span>
                          <div style={{ fontFamily: 'monospace', background: '#12141E', padding: '4px 8px', borderRadius: '6px', fontSize: '13px' }}>{k.id_number}</div>
                        </div>
                      )}
                      {k.kyc_document_type && (
                        <div>
                          <span style={{ color: '#6B6F82', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Document Type</span>
                          <div style={{ textTransform: 'capitalize' }}>{k.kyc_document_type.replace(/_/g, ' ')}</div>
                        </div>
                      )}
                      <div>
                        <span style={{ color: '#6B6F82', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Submitted</span>
                        <div>{new Date(k.created_at).toLocaleDateString('en-ZA', { day: 'numeric', month: 'short', year: 'numeric' })}</div>
                      </div>
                    </div>
                    {/* Document images */}
                    {(k.kyc_document_front || k.kyc_document_back) && (
                      <div style={{ display: 'flex', gap: '10px', marginBottom: '14px' }}>
                        {k.kyc_document_front && (
                          <a href={k.kyc_document_front} target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 12px', borderRadius: '8px', background: '#12141E', border: '1px solid #252838', color: '#A78BFA', fontSize: '12px', textDecoration: 'none', fontWeight: 500 }}>
                            <FiEye size={14} /> {k.kyc_document_back ? 'Front Document' : 'View Document'}
                          </a>
                        )}
                        {k.kyc_document_back && (
                          <a href={k.kyc_document_back} target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 12px', borderRadius: '8px', background: '#12141E', border: '1px solid #252838', color: '#A78BFA', fontSize: '12px', textDecoration: 'none', fontWeight: 500 }}>
                            <FiEye size={14} /> Back Document
                          </a>
                        )}
                      </div>
                    )}
                    {/* Action buttons */}
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <button onClick={async () => {
                        if (!window.confirm(`Approve KYC for ${k.name}?`)) return;
                        await api.put(`/admin/kyc/review/${k.id}`, { action: 'approve' });
                        loadTab();
                      }} style={{ padding: '8px 18px', borderRadius: '8px', border: 'none', background: '#10B981', color: 'white', fontSize: '13px', cursor: 'pointer', fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                        <FiCheck size={14} /> Approve
                      </button>
                      <button onClick={async () => {
                        const reason = window.prompt('Rejection reason (shown to user):');
                        if (reason === null) return;
                        await api.put(`/admin/kyc/review/${k.id}`, { action: 'reject', reason: reason || 'Documents not accepted' });
                        loadTab();
                      }} style={{ padding: '8px 18px', borderRadius: '8px', border: 'none', background: '#EF444420', color: '#EF4444', fontSize: '13px', cursor: 'pointer', fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                        <FiX size={14} /> Reject
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Disputes Tab */}
      {tab === 'disputes' && (() => {
        const statusColors = {
          open: { bg: 'rgba(239,68,68,0.12)', color: '#EF4444' },
          under_review: { bg: 'rgba(245,158,11,0.12)', color: '#F59E0B' },
          resolved: { bg: 'rgba(16,185,129,0.12)', color: '#10B981' },
          closed: { bg: 'rgba(107,111,130,0.12)', color: '#6B6F82' }
        };
        // Initialize edit state from data — store per-dispute status + notes in a single object
        const editKey = disputesData.map(d => d.id + '|' + d.status + '|' + (d.resolution_notes || '')).join(',');
        const [edits, setEdits] = React.useState(() => {
          const init = {};
          disputesData.forEach(d => {
            init[d.id] = { status: d.status, notes: d.resolution_notes || '', updating: false };
          });
          return init;
        });
        // Re-sync edits when data changes
        React.useEffect(() => {
          const sync = {};
          disputesData.forEach(d => {
            sync[d.id] = { status: d.status, notes: d.resolution_notes || '', updating: false };
          });
          setEdits(sync);
        }, [editKey]);
        return (
        <div>
          <h3 style={{ fontSize: '18px', marginBottom: '20px' }}>Dispute Reports</h3>
          {disputesData.length === 0 ? (
            <div style={{ padding: '40px 20px', textAlign: 'center', color: '#6B6F82', background: '#1A1D2B', borderRadius: '12px' }}>No disputes reported yet</div>
          ) : (
            <div style={{ display: 'grid', gap: '12px' }}>
              {disputesData.map(d => {
                const sc = statusColors[d.status] || statusColors.open;
                const ed = edits[d.id] || { status: d.status, notes: d.resolution_notes || '', updating: false };
                return (
                  <div key={d.id} style={{ background: '#1A1D2B', borderRadius: '12px', padding: '20px', border: '1px solid #252838' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '12px', marginBottom: '12px' }}>
                      <div style={{ flex: 1 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                          <span style={{ fontWeight: 600, fontSize: '14px' }}>{d.name}</span>
                          <span style={{
                            display: 'inline-block', padding: '2px 8px', borderRadius: '6px', fontSize: '10px', fontWeight: 600,
                            background: d.reporter_type === 'host' ? 'rgba(96,165,250,0.15)' : 'rgba(167,139,250,0.15)',
                            color: d.reporter_type === 'host' ? '#60A5FA' : '#A78BFA'
                          }}>{d.reporter_type}</span>
                          <span style={{ fontSize: '11px', color: '#6B6F82' }}>({d.email})</span>
                        </div>
                        {d.event_title && <div style={{ fontSize: '12px', color: '#6B6F82', marginTop: '4px' }}>Event: <strong style={{ color: '#ccc' }}>{d.event_title}</strong></div>}
                        <div style={{ fontSize: '12px', color: '#6B6F82', marginTop: '2px' }}>
                          Booking #{d.booking_id} &bull; Status: <span style={{ color: '#ccc', fontWeight: 500 }}>{d.booking_status}</span>
                          {d.total_amount > 0 && <> &bull; R{Number(d.total_amount).toLocaleString()}</>}
                          &bull; <span style={{ fontSize: '11px' }}>{new Date(d.created_at).toLocaleDateString('en-ZA', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</span>
                        </div>
                      </div>
                      <span style={{
                        padding: '4px 10px', borderRadius: '8px', fontSize: '11px', fontWeight: 600,
                        background: sc.bg, color: sc.color
                      }}>{d.status.replace('_', ' ')}</span>
                    </div>
                    <div style={{ padding: '12px', background: '#252838', borderRadius: '8px', marginBottom: '12px' }}>
                      <div style={{ fontSize: '13px', fontWeight: 600, color: '#fff', marginBottom: '4px' }}>{d.subject}</div>
                      <div style={{ fontSize: '13px', color: '#9CA3AF', whiteSpace: 'pre-wrap' }}>{d.description}</div>
                    </div>
                    {/* Admin update section */}
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-end', flexWrap: 'wrap' }}>
                      <div>
                        <label style={{ fontSize: '11px', color: '#6B6F82', display: 'block', marginBottom: '4px' }}>Status</label>
                        <select value={ed.status} onChange={e => setEdits(prev => ({ ...prev, [d.id]: { ...prev[d.id], status: e.target.value } }))}
                          style={{ padding: '8px 12px', borderRadius: '8px', border: '1px solid #374151', background: '#1A1D2B', color: '#fff', fontSize: '13px' }}>
                          <option value="open">Open</option>
                          <option value="under_review">Under Review</option>
                          <option value="resolved">Resolved</option>
                          <option value="closed">Closed</option>
                        </select>
                      </div>
                      <div style={{ flex: 1, minWidth: '200px' }}>
                        <label style={{ fontSize: '11px', color: '#6B6F82', display: 'block', marginBottom: '4px' }}>Resolution Notes</label>
                        <textarea value={ed.notes} onChange={e => setEdits(prev => ({ ...prev, [d.id]: { ...prev[d.id], notes: e.target.value } }))}
                          placeholder="Add notes about resolution..."
                          rows={2}
                          style={{ width: '100%', padding: '8px 12px', borderRadius: '8px', border: '1px solid #374151', background: '#1A1D2B', color: '#fff', fontSize: '13px', resize: 'vertical', boxSizing: 'border-box' }} />
                      </div>
                      <button onClick={async () => {
                        setEdits(prev => ({ ...prev, [d.id]: { ...prev[d.id], updating: true } }));
                        try {
                          await api.put(`/admin/disputes/${d.id}`, { status: ed.status, resolution_notes: ed.notes });
                          loadTab();
                        } catch { alert('Failed to update'); }
                        setEdits(prev => ({ ...prev, [d.id]: { ...prev[d.id], updating: false } }));
                      }} disabled={ed.updating}
                        style={{ padding: '8px 16px', borderRadius: '8px', border: 'none', background: '#A78BFA', color: 'white', cursor: 'pointer', fontSize: '12px', fontWeight: 600, whiteSpace: 'nowrap' }}>
                        {ed.updating ? 'Saving...' : 'Update'}
                      </button>
                    </div>
                    {d.resolver_name && (
                      <div style={{ fontSize: '11px', color: '#6B6F82', marginTop: '8px' }}>
                        Last updated by: <strong style={{ color: '#ccc' }}>{d.resolver_name}</strong>
                        {d.updated_at && <> on {new Date(d.updated_at).toLocaleDateString('en-ZA', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</>}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
        );
      })()}

      {/* Notify User Modal */}
      {notifyModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, backdropFilter: 'blur(4px)' }} onClick={e => { if (e.target === e.currentTarget) setNotifyModal(null); }}>
          <div style={{ background: '#1A1D2B', borderRadius: '16px', padding: isMobile ? '20px 16px' : '28px', maxWidth: '440px', width: isMobile ? 'calc(100% - 32px)' : '100%', border: '1px solid #252838', margin: isMobile ? '0 16px' : 0 }}>
            <h3 style={{ marginBottom: '16px', fontSize: '18px' }}>Send Notification</h3>
            <div style={{ marginBottom: '14px' }}>
              <label style={cs.label}>Title</label>
              <input value={notifyData.title} onChange={e => setNotifyData({ ...notifyData, title: e.target.value })} placeholder="e.g., Account Notice" style={cs.input} />
            </div>
            <div style={{ marginBottom: '20px' }}>
              <label style={cs.label}>Message</label>
              <textarea value={notifyData.message} onChange={e => setNotifyData({ ...notifyData, message: e.target.value })} rows={4} placeholder="Type your message..." style={{ ...cs.input, resize: 'vertical' }} />
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button onClick={() => setNotifyModal(null)} style={cs.btnOutline}>Cancel</button>
              <button onClick={sendNotification} style={cs.btn('#A78BFA')}><FiSend size={14} /> Send</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

